/* eslint-disable */
import * as schema from '../schema';
import { DayOfWeek, Instant, LocalDate, LocalDateTime, LocalTime } from "@js-joda/core"
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AgencyBranchId: schema.AgencyBranchId;
  AgencyId: schema.AgencyId;
  AgencyMemberId: schema.AgencyMemberId;
  AgencyPhonebookContactId: schema.AgencyPhonebookContactId;
  AgencyTeamId: schema.AgencyTeamId;
  Any: any;
  AuthorizationId: schema.AuthorizationId;
  AuthorizationTimeConfig: schema.components["schemas"]["AuthorizationTimeConfig"];
  CaregiverCertification: schema.components["schemas"]["CaregiverCertification"];
  CaregiverId: schema.CaregiverId;
  CaregiverStatus: schema.components["schemas"]["CaregiverStatus"];
  CaregiverVisitEngagementId: unknown;
  CertificationPeriodId: schema.CertificationPeriodId;
  CommCenterLabelId: schema.CommCenterLabelId;
  CommCenterMessageActionId: schema.CommCenterMessageActionId;
  CommCenterTeamId: schema.CommCenterTeamId;
  CommCenterTicketId: schema.CommCenterTicketId;
  ContractTypeId: schema.ContractTypeId;
  EntityCustomField: schema.components["schemas"]["EntityCustomField"];
  Geo: schema.components["schemas"]["Geo"];
  ImportedVisitId: schema.ImportedVisitId;
  Instant: Instant;
  LocalDate: LocalDate;
  LocalDateTime: LocalDateTime;
  MedflytCHRCDataId: schema.MedflytCHRCDataId;
  MedflytHCRDataId: schema.MedflytHCRDataId;
  NoteId: schema.NoteId;
  OfficeId: schema.OfficeId;
  PatientContractId: schema.PatientContractId;
  PatientGender: schema.components["schemas"]["Patient"]["gender"];
  PatientId: schema.PatientId;
  PatientIssueId: schema.PatientIssueId;
  PatientStatus: schema.components["schemas"]["PatientStatus"];
  PatientTaskId: schema.PatientTaskId;
  PatientTaskInstanceId: schema.PatientTaskInstanceId;
  PatientWebsiteVisitorEventId: unknown;
  PatientWebsiteVisitorId: unknown;
  PatientWebsiteVisitorVisitId: unknown;
  PayerId: schema.PayerId;
  PermissionControlledField_DayOfWeek: PermissionControlledField_DayOfWeek;
  PermissionControlledField_Instant: PermissionControlledField_Instant;
  PermissionControlledField_LocalDate: PermissionControlledField_LocalDate;
  PermissionControlledField_LocalDateTime: PermissionControlledField_LocalDateTime;
  ReferralUserId: schema.ReferralUserId;
  ServiceCodeId: schema.ServiceCodeId;
  UserId: schema.UserId;
  VisitAssignmentId: schema.VisitAssignmentId;
  VisitBroadcastId: schema.VisitBroadcastId;
  VisitInstanceId: schema.VisitInstanceId;
  WorkflowDefinitionCorrelationKey: schema.WorkflowDefinitionCorrelationKey;
  WorkflowDefinitionId: schema.WorkflowDefinitionId;
  WorkflowDefinitionTriggerId: schema.WorkflowDefinitionTriggerId;
  WorkflowExecutionValueObject: schema.components["schemas"]["WorkflowExecutionValueObject"];
  WorkflowInputs: schema.components["schemas"]["WorkflowInputs"];
  WorkflowInstanceId: schema.WorkflowInstanceId;
  WorkflowInstanceOrigin: schema.components["schemas"]["WorkflowInstanceOrigin"];
  WorkflowSkillId: schema.WorkflowSkillId;
  WorkflowTagId: schema.WorkflowTagId;
  WorkflowTaskClusterId: schema.WorkflowTaskClusterId;
  WorkflowTaskInstanceId: schema.WorkflowTaskInstanceId;
};

export type AgencyBranch = {
  __typename?: 'AgencyBranch';
  id: Scalars['AgencyBranchId'];
  name: Scalars['String'];
  patients: AgencyBranchPatientAssocConnection;
};


export type AgencyBranchPatientsArgs = {
  agencyBranch?: InputMaybe<AgencyBranch_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patient?: InputMaybe<Patient_RelationFilter>;
};

export type AgencyBranchConnection = {
  __typename?: 'AgencyBranchConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyBranch>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type AgencyBranchId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyBranchId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyBranchId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyBranchId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyBranchId']>>;
};

export type AgencyBranchPatientAssoc = {
  __typename?: 'AgencyBranchPatientAssoc';
  agencyBranch: AgencyBranch;
  agencyBranchId: Scalars['AgencyBranchId'];
  patient: Patient;
  patientId: Scalars['PatientId'];
};

export type AgencyBranchPatientAssocConnection = {
  __typename?: 'AgencyBranchPatientAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyBranchPatientAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyBranch_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyBranchId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyBranch__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyBranch__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyBranch__OrderField {
  Id = 'id',
  Name = 'name'
}

/** Filter result rows based on the value of a field */
export type AgencyId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyId']>>;
};

export type AgencyMemberAgency = {
  __typename?: 'AgencyMemberAgency';
  id: Scalars['AgencyId'];
  name: Scalars['String'];
  website: Scalars['String'];
};

export type AgencyMemberAgencyConnection = {
  __typename?: 'AgencyMemberAgencyConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberAgency>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberAgencyMember = {
  __typename?: 'AgencyMemberAgencyMember';
  agency: AgencyMemberAgency;
  agencyId: Scalars['AgencyId'];
  firstName: Scalars['String'];
  full_name: Scalars['String'];
  id: Scalars['AgencyMemberId'];
  lastName: Scalars['String'];
  offices: AgencyMemberOfficeAssocConnection;
  photoUrl: Maybe<Scalars['String']>;
};


export type AgencyMemberAgencyMemberOfficesArgs = {
  agencyMember?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  office?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  officeId?: InputMaybe<OfficeId_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberOfficeAssoc__Order>>>;
};

export type AgencyMemberAgencyMemberConnection = {
  __typename?: 'AgencyMemberAgencyMemberConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberAgencyMember>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberAgencyMember_RelationFilter = {
  /** Filter based on "agencyId" field */
  agencyId?: InputMaybe<AgencyId_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyMemberId_Filter>;
  /** Search by first name or last name */
  nameSearch?: InputMaybe<Scalars['String']>;
};

export type AgencyMemberAgencyMember__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberAgencyMember__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberAgencyMember__OrderField {
  AgencyId = 'agencyId',
  Id = 'id'
}

export type AgencyMemberAgency_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyMemberAgency__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberAgency__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberAgency__OrderField {
  Id = 'id',
  Name = 'name'
}

export type AgencyMemberAvailableWorkflowTaskInstance = {
  __typename?: 'AgencyMemberAvailableWorkflowTaskInstance';
  assignee: Maybe<AgencyMemberAgencyMember>;
  assigneeId: Maybe<Scalars['AgencyMemberId']>;
  assignmentTimeoutSeconds: Maybe<Scalars['Int']>;
  clusterId: Maybe<Scalars['WorkflowTaskClusterId']>;
  clusterValue: Maybe<Scalars['String']>;
  correlationKey: Scalars['WorkflowDefinitionCorrelationKey'];
  createdAt: Scalars['Instant'];
  description: Maybe<Scalars['String']>;
  id: Scalars['WorkflowTaskInstanceId'];
  instanceEntities: AgencyMemberWorkflowInstanceInputEntitiesConnection;
  mandatory: Scalars['Boolean'];
  name: Scalars['String'];
  ownerId: Scalars['AgencyMemberId'];
  priority: Scalars['Int'];
  severity: Scalars['String'];
  skills: AgencyMemberWorkflowTaskSkillConnection;
  workflowDefinition: AgencyMemberWorkflowDefinition;
  workflowDefinitionId: Scalars['WorkflowDefinitionId'];
  workflowDefinitionName: Scalars['String'];
  workflowInstanceId: Scalars['WorkflowInstanceId'];
  workflowTaskDefinitionId: Scalars['String'];
};


export type AgencyMemberAvailableWorkflowTaskInstanceInstanceEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AgencyMemberAvailableWorkflowTaskInstanceSkillsArgs = {
  id?: InputMaybe<WorkflowSkillId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskSkill__Order>>>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};

export type AgencyMemberAvailableWorkflowTaskInstanceConnection = {
  __typename?: 'AgencyMemberAvailableWorkflowTaskInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberAvailableWorkflowTaskInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberAvailableWorkflowTaskInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberAvailableWorkflowTaskInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberAvailableWorkflowTaskInstance__OrderField {
  AssigneeId = 'assigneeId',
  ClusterId = 'clusterId',
  CorrelationKey = 'correlationKey',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Mandatory = 'mandatory',
  Name = 'name',
  OwnerId = 'ownerId',
  Priority = 'priority',
  Severity = 'severity',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowDefinitionName = 'workflowDefinitionName',
  WorkflowInstanceId = 'workflowInstanceId',
  WorkflowTaskDefinitionId = 'workflowTaskDefinitionId'
}

export type AgencyMemberCaregiver = {
  __typename?: 'AgencyMemberCaregiver';
  avatarUrl: Maybe<Scalars['String']>;
  branches: AgencyMemberCaregiverBranchAssocConnection;
  caregiverCode: Maybe<Scalars['String']>;
  certifications: Array<Scalars['CaregiverCertification']>;
  chrcCompliance: Maybe<AgencyMemberCaregiverChrcCompliance>;
  createdAt: Scalars['Instant'];
  dateOfBirth: Maybe<Scalars['LocalDate']>;
  displayId: Maybe<Scalars['Int']>;
  email: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender: Scalars['PatientGender'];
  hcrCompliance: Maybe<AgencyMemberCaregiverHcrCompliance>;
  hireDate: Maybe<Scalars['LocalDate']>;
  id: Scalars['CaregiverId'];
  languages: Array<Scalars['String']>;
  lastName: Scalars['String'];
  middleName: Maybe<Scalars['String']>;
  offices: CaregiverOfficeAssocConnection;
  phoneNumbers: AgencyMemberCaregiverPhoneNumberConnection;
  ssn: Maybe<Scalars['String']>;
  stateRegistryNum: Maybe<Scalars['Int']>;
  status: Scalars['CaregiverStatus'];
  terminationDate: Maybe<Scalars['LocalDate']>;
  visitBroadcasts: VisitBroadcastBroadcastedToConnection;
  visitInstances: AgencyMemberVisitInstanceConnection;
  workAreaPreference: Maybe<Scalars['String']>;
};


export type AgencyMemberCaregiverBranchesArgs = {
  agencyBranch?: InputMaybe<AgencyBranch_RelationFilter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AgencyMemberCaregiverOfficesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  office?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AgencyMemberCaregiverPhoneNumbersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AgencyMemberCaregiverVisitBroadcastsArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastBroadcastedTo__Order>>>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type AgencyMemberCaregiverVisitInstancesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  id?: InputMaybe<VisitInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitInstance__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};

export type AgencyMemberCaregiverBranchAssoc = {
  __typename?: 'AgencyMemberCaregiverBranchAssoc';
  agencyBranch: AgencyBranch;
  agencyBranchId: Scalars['AgencyBranchId'];
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId'];
};

export type AgencyMemberCaregiverBranchAssocConnection = {
  __typename?: 'AgencyMemberCaregiverBranchAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverBranchAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberCaregiverChrcCompliance = {
  __typename?: 'AgencyMemberCaregiverChrcCompliance';
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  chrcDateOfBirth: Scalars['LocalDate'];
  chrcEmployeeName: Scalars['String'];
  chrcStartDate: Scalars['LocalDate'];
  chrcStatus: Scalars['String'];
  chrcStatusDate: Scalars['LocalDate'];
  dateOfBirth: Maybe<Scalars['LocalDate']>;
  hireDate: Maybe<Scalars['LocalDate']>;
  id: Scalars['MedflytCHRCDataId'];
  stateRegistryNum: Maybe<Scalars['Int']>;
  status: Maybe<Scalars['CaregiverStatus']>;
  terminationDate: Maybe<Scalars['LocalDate']>;
};

export type AgencyMemberCaregiverChrcComplianceConnection = {
  __typename?: 'AgencyMemberCaregiverChrcComplianceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverChrcCompliance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberCaregiverChrcCompliance_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  /** Filter based on "chrcDateOfBirth" field */
  chrcDateOfBirth?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "chrcEmployeeName" field */
  chrcEmployeeName?: InputMaybe<String_Filter>;
  /** Filter based on "chrcStartDate" field */
  chrcStartDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "chrcStatus" field */
  chrcStatus?: InputMaybe<String_Filter>;
  /** Filter based on "chrcStatusDate" field */
  chrcStatusDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "dateOfBirth" field */
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromChrcStartDate?: InputMaybe<Scalars['LocalDate']>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']>;
  /** Filter based on "hireDate" field */
  hireDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<MedflytChrcDataId_Filter>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  /** Filter based on "stateRegistryNum" field */
  stateRegistryNum?: InputMaybe<Int_Filter>;
  /** Filter based on "status" field */
  status?: InputMaybe<String_Filter>;
  /** Filter based on "terminationDate" field */
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toChrcStartDate?: InputMaybe<Scalars['LocalDate']>;
  toHireDate?: InputMaybe<Scalars['LocalDate']>;
};

export type AgencyMemberCaregiverChrcCompliance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiverChrcCompliance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiverChrcCompliance__OrderField {
  CaregiverId = 'caregiverId',
  ChrcDateOfBirth = 'chrcDateOfBirth',
  ChrcEmployeeName = 'chrcEmployeeName',
  ChrcStartDate = 'chrcStartDate',
  ChrcStatus = 'chrcStatus',
  ChrcStatusDate = 'chrcStatusDate',
  DateOfBirth = 'dateOfBirth',
  HireDate = 'hireDate',
  Id = 'id',
  StateRegistryNum = 'stateRegistryNum',
  Status = 'status',
  TerminationDate = 'terminationDate'
}

export type AgencyMemberCaregiverConnection = {
  __typename?: 'AgencyMemberCaregiverConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiver>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberCaregiverHcrCompliance = {
  __typename?: 'AgencyMemberCaregiverHcrCompliance';
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  dateOfBirth: Maybe<Scalars['LocalDate']>;
  hcrCertificateType: Scalars['String'];
  hcrDateOfBirth: Scalars['LocalDate'];
  hcrFullName: Scalars['String'];
  hcrHireDate: Maybe<Scalars['LocalDate']>;
  hcrSeparationDate: Maybe<Scalars['LocalDate']>;
  hcrStateRegistryNumber: Maybe<Scalars['Int']>;
  hireDate: Maybe<Scalars['LocalDate']>;
  id: Scalars['MedflytHCRDataId'];
  stateRegistryNum: Maybe<Scalars['Int']>;
  status: Maybe<Scalars['CaregiverStatus']>;
  terminationDate: Maybe<Scalars['LocalDate']>;
};

export type AgencyMemberCaregiverHcrComplianceConnection = {
  __typename?: 'AgencyMemberCaregiverHcrComplianceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverHcrCompliance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberCaregiverHcrCompliance_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  /** Filter based on "dateOfBirth" field */
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']>;
  /** Filter based on "hcrCertificateType" field */
  hcrCertificateType?: InputMaybe<String_Filter>;
  /** Filter based on "hcrDateOfBirth" field */
  hcrDateOfBirth?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "hcrFullName" field */
  hcrFullName?: InputMaybe<String_Filter>;
  /** Filter based on "hcrHireDate" field */
  hcrHireDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "hcrSeparationDate" field */
  hcrSeparationDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "hcrStateRegistryNumber" field */
  hcrStateRegistryNumber?: InputMaybe<Int_Filter>;
  /** Filter based on "hireDate" field */
  hireDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<MedflytHcrDataId_Filter>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  /** Filter based on "stateRegistryNum" field */
  stateRegistryNum?: InputMaybe<Int_Filter>;
  /** Filter based on "status" field */
  status?: InputMaybe<String_Filter>;
  /** Filter based on "terminationDate" field */
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toHireDate?: InputMaybe<Scalars['LocalDate']>;
};

export type AgencyMemberCaregiverHcrCompliance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiverHcrCompliance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiverHcrCompliance__OrderField {
  CaregiverId = 'caregiverId',
  DateOfBirth = 'dateOfBirth',
  HcrCertificateType = 'hcrCertificateType',
  HcrDateOfBirth = 'hcrDateOfBirth',
  HcrFullName = 'hcrFullName',
  HcrHireDate = 'hcrHireDate',
  HcrSeparationDate = 'hcrSeparationDate',
  HcrStateRegistryNumber = 'hcrStateRegistryNumber',
  HireDate = 'hireDate',
  Id = 'id',
  StateRegistryNum = 'stateRegistryNum',
  Status = 'status',
  TerminationDate = 'terminationDate'
}

export type AgencyMemberCaregiverPhoneNumber = {
  __typename?: 'AgencyMemberCaregiverPhoneNumber';
  caregiverId: Scalars['CaregiverId'];
  isSmsable: Scalars['Boolean'];
  phoneNumber: Scalars['String'];
};

export type AgencyMemberCaregiverPhoneNumberConnection = {
  __typename?: 'AgencyMemberCaregiverPhoneNumberConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverPhoneNumber>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberCaregiverStateCompliance = {
  __typename?: 'AgencyMemberCaregiverStateCompliance';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId'];
  issue: StateComplianceIssueType;
};

export type AgencyMemberCaregiverStateComplianceConnection = {
  __typename?: 'AgencyMemberCaregiverStateComplianceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverStateCompliance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberCaregiverStateCompliance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiverStateCompliance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiverStateCompliance__OrderField {
  CaregiverId = 'caregiverId',
  Issue = 'issue'
}

export type AgencyMemberCaregiver_RelationFilter = {
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "firstName" field */
  firstName?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CaregiverId_Filter>;
  /** Filter based on "lastName" field */
  lastName?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['Instant']>;
};

export type AgencyMemberCaregiver__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiver__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiver__OrderField {
  CreatedAt = 'createdAt',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName'
}

/** Filter result rows based on the value of a field */
export type AgencyMemberId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyMemberId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyMemberId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyMemberId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyMemberId']>>;
};

export type AgencyMemberImportedVisit = {
  __typename?: 'AgencyMemberImportedVisit';
  caregiverId: Scalars['CaregiverId'];
  endTimeLocal: Scalars['LocalDateTime'];
  id: Scalars['ImportedVisitId'];
  startTimeLocal: Scalars['LocalDateTime'];
};

export type AgencyMemberImportedVisitConnection = {
  __typename?: 'AgencyMemberImportedVisitConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberImportedVisit>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberImportedVisit_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  /** Filter based on "endTimeLocal" field */
  endTimeLocal?: InputMaybe<LocalDateTime_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<ImportedVisitId_Filter>;
  /** Filter based on "startTimeLocal" field */
  startTimeLocal?: InputMaybe<LocalDateTime_Filter>;
};

export type AgencyMemberImportedVisit__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberImportedVisit__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberImportedVisit__OrderField {
  CaregiverId = 'caregiverId',
  EndTimeLocal = 'endTimeLocal',
  Id = 'id',
  StartTimeLocal = 'startTimeLocal'
}

export type AgencyMemberOffice = {
  __typename?: 'AgencyMemberOffice';
  active: Scalars['Boolean'];
  addressText: Scalars['String'];
  addressTimezone: Scalars['String'];
  caregivers: CaregiverOfficeAssocConnection;
  id: Scalars['OfficeId'];
  name: Scalars['String'];
};


export type AgencyMemberOfficeCaregiversArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  office?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AgencyMemberOfficeAssoc = {
  __typename?: 'AgencyMemberOfficeAssoc';
  agencyMember: AgencyMemberAgencyMember;
  office: AgencyMemberOffice;
};

export type AgencyMemberOfficeAssocConnection = {
  __typename?: 'AgencyMemberOfficeAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberOfficeAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberOfficeAssoc__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberOfficeAssoc__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberOfficeAssoc__OrderField {
  OfficeId = 'officeId'
}

export type AgencyMemberOfficeConnection = {
  __typename?: 'AgencyMemberOfficeConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberOffice>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberOffice_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<OfficeId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyMemberOffice__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberOffice__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberOffice__OrderField {
  Id = 'id',
  Name = 'name'
}

export type AgencyMemberPatientLeadQualifications = {
  __typename?: 'AgencyMemberPatientLeadQualifications';
  disqualifiedAt: Maybe<Scalars['Instant']>;
  isQualified: Scalars['Boolean'];
  patient: Patient;
  patientId: Scalars['PatientId'];
  qualifiedAt: Maybe<Scalars['Instant']>;
  qualifiedReason: Maybe<PatientQualifiedLeadReason>;
};

export type AgencyMemberPatientLeadQualificationsConnection = {
  __typename?: 'AgencyMemberPatientLeadQualificationsConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientLeadQualifications>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberPatientLeadQualifications__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientLeadQualifications__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientLeadQualifications__OrderField {
  DisqualifiedAt = 'disqualifiedAt',
  IsQualified = 'isQualified',
  PatientId = 'patientId',
  QualifiedAt = 'qualifiedAt',
  QualifiedReason = 'qualifiedReason'
}

export type AgencyMemberPatientWebsiteVisitor = {
  __typename?: 'AgencyMemberPatientWebsiteVisitor';
  createdAt: Scalars['Instant'];
  events: AgencyMemberPatientWebsiteVisitorEventConnection;
  id: Scalars['PatientWebsiteVisitorId'];
  patient: Patient;
  patientId: Maybe<Scalars['PatientId']>;
  uuid: Scalars['String'];
  visits: AgencyMemberPatientWebsiteVisitorVisitConnection;
};


export type AgencyMemberPatientWebsiteVisitorEventsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  eventName?: InputMaybe<String_Filter>;
  eventType?: InputMaybe<String_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorEventId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__Order>>>;
  visit?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit_RelationFilter>;
  visitId?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};


export type AgencyMemberPatientWebsiteVisitorVisitsArgs = {
  adContent?: InputMaybe<String_Filter>;
  adGroup?: InputMaybe<String_Filter>;
  assignedPhoneNumber?: InputMaybe<String_Filter>;
  campaign?: InputMaybe<String_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorVisit__Order>>>;
  searchTerm?: InputMaybe<String_Filter>;
  source?: InputMaybe<String_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};

export type AgencyMemberPatientWebsiteVisitorConnection = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientWebsiteVisitor>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberPatientWebsiteVisitorEvent = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorEvent';
  createdAt: Scalars['Instant'];
  eventName: Scalars['String'];
  eventType: Scalars['String'];
  id: Scalars['PatientWebsiteVisitorEventId'];
  visit: AgencyMemberPatientWebsiteVisitorVisit;
  visitId: Scalars['PatientWebsiteVisitorVisitId'];
  visitor: AgencyMemberPatientWebsiteVisitor;
  websiteVisitorId: Scalars['PatientWebsiteVisitorId'];
};

export type AgencyMemberPatientWebsiteVisitorEventConnection = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorEventConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientWebsiteVisitorEvent>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberPatientWebsiteVisitorEvent__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientWebsiteVisitorEvent__OrderField {
  CreatedAt = 'createdAt',
  EventName = 'eventName',
  EventType = 'eventType',
  Id = 'id',
  VisitId = 'visitId',
  WebsiteVisitorId = 'websiteVisitorId'
}

export type AgencyMemberPatientWebsiteVisitorVisit = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorVisit';
  adContent: Maybe<Scalars['String']>;
  adGroup: Maybe<Scalars['String']>;
  assignedPhoneNumber: Maybe<Scalars['String']>;
  campaign: Maybe<Scalars['String']>;
  createdAt: Scalars['Instant'];
  events: AgencyMemberPatientWebsiteVisitorEventConnection;
  id: Scalars['PatientWebsiteVisitorVisitId'];
  medium: Maybe<Scalars['String']>;
  searchTerm: Maybe<Scalars['String']>;
  source: Scalars['String'];
  visitor: AgencyMemberPatientWebsiteVisitor;
  websiteVisitorId: Scalars['PatientWebsiteVisitorId'];
};


export type AgencyMemberPatientWebsiteVisitorVisitEventsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  eventName?: InputMaybe<String_Filter>;
  eventType?: InputMaybe<String_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorEventId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__Order>>>;
  visit?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit_RelationFilter>;
  visitId?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};

export type AgencyMemberPatientWebsiteVisitorVisitConnection = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorVisitConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientWebsiteVisitorVisit>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberPatientWebsiteVisitorVisit_RelationFilter = {
  /** Filter based on "adContent" field */
  adContent?: InputMaybe<String_Filter>;
  /** Filter based on "adGroup" field */
  adGroup?: InputMaybe<String_Filter>;
  /** Filter based on "assignedPhoneNumber" field */
  assignedPhoneNumber?: InputMaybe<String_Filter>;
  /** Filter based on "campaign" field */
  campaign?: InputMaybe<String_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  /** Filter based on "medium" field */
  medium?: InputMaybe<String_Filter>;
  /** Filter based on "searchTerm" field */
  searchTerm?: InputMaybe<String_Filter>;
  /** Filter based on "source" field */
  source?: InputMaybe<String_Filter>;
  /** Filter based on "websiteVisitorId" field */
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};

export type AgencyMemberPatientWebsiteVisitorVisit__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientWebsiteVisitorVisit__OrderField {
  AdContent = 'adContent',
  AdGroup = 'adGroup',
  AssignedPhoneNumber = 'assignedPhoneNumber',
  Campaign = 'campaign',
  CreatedAt = 'createdAt',
  Id = 'id',
  Medium = 'medium',
  SearchTerm = 'searchTerm',
  Source = 'source',
  WebsiteVisitorId = 'websiteVisitorId'
}

export type AgencyMemberPatientWebsiteVisitor_RelationFilter = {
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<PatientWebsiteVisitorId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  /** Filter based on "uuid" field */
  uuid?: InputMaybe<String_Filter>;
};

export type AgencyMemberPatientWebsiteVisitor__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientWebsiteVisitor__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientWebsiteVisitor__OrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  PatientId = 'patientId',
  Uuid = 'uuid'
}

export type AgencyMemberVisitBroadcast = {
  __typename?: 'AgencyMemberVisitBroadcast';
  broadcastedTo: VisitBroadcastBroadcastedToConnection;
  canceledAt: Maybe<Scalars['Instant']>;
  createdAt: Scalars['Instant'];
  endTimeLocal: Scalars['LocalDateTime'];
  endTimeUTC: Scalars['Instant'];
  engagements: VisitBroadcastCaregiverEngagementConnection;
  id: Scalars['VisitBroadcastId'];
  notBroadcastedTo: VisitBroadcastNotBroadcastedToConnection;
  radiusMeters: Maybe<Scalars['Float']>;
  startTimeLocal: Scalars['LocalDateTime'];
  startTimeUTC: Scalars['Instant'];
  visitInstances: VisitBroadcastAssocConnection;
};


export type AgencyMemberVisitBroadcastBroadcastedToArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastBroadcastedTo__Order>>>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type AgencyMemberVisitBroadcastEngagementsArgs = {
  acceptedTime?: InputMaybe<Instant_Filter>;
  active?: InputMaybe<Boolean_Filter>;
  cancelTime?: InputMaybe<Instant_Filter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<CaregiverVisitEngagementId_Filter>;
  isRequestActive?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  moreDetailsViewedAt?: InputMaybe<Instant_Filter>;
  notInterestedReason?: InputMaybe<String_Filter>;
  notInterestedTime?: InputMaybe<Instant_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastCaregiverEngagement__Order>>>;
  viewedAt?: InputMaybe<Instant_Filter>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitBroadcastId?: InputMaybe<VisitBroadcastId_Filter>;
};


export type AgencyMemberVisitBroadcastNotBroadcastedToArgs = {
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverMarkedNotInterested?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastNotBroadcastedTo__Order>>>;
};


export type AgencyMemberVisitBroadcastVisitInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitInstances?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type AgencyMemberVisitBroadcastConnection = {
  __typename?: 'AgencyMemberVisitBroadcastConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberVisitBroadcast>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberVisitBroadcast_RelationFilter = {
  /** Filter based on "canceledAt" field */
  canceledAt?: InputMaybe<Instant_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<VisitBroadcastId_Filter>;
};

export type AgencyMemberVisitBroadcast__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberVisitBroadcast__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberVisitBroadcast__OrderField {
  CanceledAt = 'canceledAt',
  CreatedAt = 'createdAt',
  EndTimeLocal = 'endTimeLocal',
  EndTimeUtc = 'endTimeUTC',
  Id = 'id',
  StartTimeLocal = 'startTimeLocal',
  StartTimeUtc = 'startTimeUTC'
}

export type AgencyMemberVisitInstance = {
  __typename?: 'AgencyMemberVisitInstance';
  addressTimezone: Scalars['String'];
  authorizationAllocations: VisitInstanceAuthorizationAllocationConnection;
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  endTimeLocal: Scalars['PermissionControlledField_LocalDateTime'];
  endTimeUTC: Scalars['PermissionControlledField_Instant'];
  id: Scalars['VisitInstanceId'];
  isBilled: Scalars['Boolean'];
  isPaid: Scalars['Boolean'];
  patient: Patient;
  patientId: Scalars['PatientId'];
  startTimeLocal: Scalars['PermissionControlledField_LocalDateTime'];
  startTimeUTC: Scalars['PermissionControlledField_Instant'];
  visitBroadcasts: VisitBroadcastAssocConnection;
  visit_date: Scalars['PermissionControlledField_LocalDate'];
  visit_day_of_week: Scalars['PermissionControlledField_DayOfWeek'];
};


export type AgencyMemberVisitInstanceAuthorizationAllocationsArgs = {
  authorization?: InputMaybe<PatientAuthorization_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};


export type AgencyMemberVisitInstanceVisitBroadcastsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitInstances?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type AgencyMemberVisitInstanceConnection = {
  __typename?: 'AgencyMemberVisitInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberVisitInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberVisitInstance_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  /** Filter based on "id" field */
  id?: InputMaybe<VisitInstanceId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
};

export type AgencyMemberVisitInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberVisitInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberVisitInstance__OrderField {
  CaregiverId = 'caregiverId',
  Id = 'id',
  PatientId = 'patientId'
}

export type AgencyMemberWorkflowDefinition = {
  __typename?: 'AgencyMemberWorkflowDefinition';
  children: Scalars['String'];
  correlationKey: Scalars['WorkflowDefinitionCorrelationKey'];
  createHumanTaskOnFailure: Scalars['Boolean'];
  createdAt: Scalars['Instant'];
  description: Scalars['String'];
  id: Scalars['WorkflowDefinitionId'];
  input: Scalars['WorkflowInputs'];
  inputHidden: Scalars['String'];
  name: Scalars['String'];
  output: Scalars['String'];
  owner: AgencyMemberAgencyMember;
  ownerId: Scalars['AgencyMemberId'];
  priority: Scalars['Int'];
  published: Scalars['Boolean'];
  severity: Scalars['String'];
  timeout: Scalars['Int'];
  version: Scalars['Int'];
  versions: AgencyMemberWorkflowDefinitionConnection;
  workflowInstances: AgencyMemberWorkflowInstanceConnection;
};


export type AgencyMemberWorkflowDefinitionVersionsArgs = {
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  createHumanTaskOnFailure?: InputMaybe<Boolean_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowDefinitionId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowDefinition__Order>>>;
  owner?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  priority?: InputMaybe<Int_Filter>;
  published?: InputMaybe<Boolean_Filter>;
  severity?: InputMaybe<String_Filter>;
  timeout?: InputMaybe<Int_Filter>;
  version?: InputMaybe<Int_Filter>;
};


export type AgencyMemberWorkflowDefinitionWorkflowInstancesArgs = {
  canceledAt?: InputMaybe<Instant_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  completedAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowInstance__Order>>>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']>>;
  startedAt?: InputMaybe<Instant_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']>;
  status?: InputMaybe<String_Filter>;
  success?: InputMaybe<Boolean_Filter>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowManualStartedBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  workflowManualStartedById?: InputMaybe<AgencyMemberId_Filter>;
  workflowTriggerId?: InputMaybe<WorkflowDefinitionTriggerId_Filter>;
  workflowTriggerTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  workflowTriggerType?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowDefinitionConnection = {
  __typename?: 'AgencyMemberWorkflowDefinitionConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowDefinition>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowDefinition_RelationFilter = {
  /** Filter based on "correlationKey" field */
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  /** Filter based on "createHumanTaskOnFailure" field */
  createHumanTaskOnFailure?: InputMaybe<Boolean_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowDefinitionId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "ownerId" field */
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "priority" field */
  priority?: InputMaybe<Int_Filter>;
  /** Filter based on "published" field */
  published?: InputMaybe<Boolean_Filter>;
  /** Filter based on "severity" field */
  severity?: InputMaybe<String_Filter>;
  /** Filter based on "timeout" field */
  timeout?: InputMaybe<Int_Filter>;
  /** Filter based on "version" field */
  version?: InputMaybe<Int_Filter>;
};

export type AgencyMemberWorkflowDefinition__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowDefinition__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowDefinition__OrderField {
  CorrelationKey = 'correlationKey',
  CreateHumanTaskOnFailure = 'createHumanTaskOnFailure',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  OwnerId = 'ownerId',
  Priority = 'priority',
  Published = 'published',
  Severity = 'severity',
  Timeout = 'timeout',
  Version = 'version'
}

export type AgencyMemberWorkflowInstance = {
  __typename?: 'AgencyMemberWorkflowInstance';
  canceledAt: Maybe<Scalars['Instant']>;
  completedAt: Maybe<Scalars['Instant']>;
  id: Scalars['WorkflowInstanceId'];
  input: Scalars['WorkflowExecutionValueObject'];
  origin: Scalars['WorkflowInstanceOrigin'];
  output: Maybe<Scalars['String']>;
  startedAt: Scalars['Instant'];
  status: Scalars['String'];
  success: Scalars['Boolean'];
  workflowDefinition: AgencyMemberWorkflowDefinition;
  workflowDefinitionCorrelationKey: Scalars['WorkflowDefinitionCorrelationKey'];
  workflowDefinitionId: Scalars['WorkflowDefinitionId'];
  workflowManualStartedBy: AgencyMemberAgencyMember;
  workflowManualStartedById: Maybe<Scalars['AgencyMemberId']>;
  workflowManualTriggerName: Maybe<Scalars['String']>;
  workflowTriggerEventTable: Maybe<Scalars['String']>;
  workflowTriggerEventType: Maybe<Scalars['String']>;
  workflowTriggerId: Maybe<Scalars['WorkflowDefinitionTriggerId']>;
  workflowTriggerReportKey: Maybe<Scalars['String']>;
  workflowTriggerTaskInstanceId: Maybe<Scalars['WorkflowTaskInstanceId']>;
  workflowTriggerType: Scalars['String'];
  workflowTriggeringWorkflowId: Maybe<Scalars['WorkflowInstanceId']>;
  workflowTriggeringWorkflowName: Maybe<Scalars['String']>;
};

export type AgencyMemberWorkflowInstanceConnection = {
  __typename?: 'AgencyMemberWorkflowInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowInstanceInputEntities = {
  __typename?: 'AgencyMemberWorkflowInstanceInputEntities';
  entity: Scalars['String'];
  key: Scalars['String'];
  value: Scalars['Any'];
};

export type AgencyMemberWorkflowInstanceInputEntitiesConnection = {
  __typename?: 'AgencyMemberWorkflowInstanceInputEntitiesConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowInstanceInputEntities>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowInstance_RelationFilter = {
  /** Filter based on "canceledAt" field */
  canceledAt?: InputMaybe<Instant_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  /** Filter based on "completedAt" field */
  completedAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowInstanceId_Filter>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']>>;
  /** Filter based on "startedAt" field */
  startedAt?: InputMaybe<Instant_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']>;
  /** Filter based on "status" field */
  status?: InputMaybe<String_Filter>;
  /** Filter based on "success" field */
  success?: InputMaybe<Boolean_Filter>;
  /** Filter based on "workflowDefinitionCorrelationKey" field */
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  /** Filter based on "workflowDefinitionId" field */
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  /** Filter based on "workflowManualStartedById" field */
  workflowManualStartedById?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "workflowTriggerId" field */
  workflowTriggerId?: InputMaybe<WorkflowDefinitionTriggerId_Filter>;
  /** Filter based on "workflowTriggerTaskInstanceId" field */
  workflowTriggerTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  /** Filter based on "workflowTriggerType" field */
  workflowTriggerType?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowInstance__OrderField {
  CanceledAt = 'canceledAt',
  CompletedAt = 'completedAt',
  Id = 'id',
  StartedAt = 'startedAt',
  Status = 'status',
  Success = 'success',
  WorkflowDefinitionCorrelationKey = 'workflowDefinitionCorrelationKey',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowManualStartedById = 'workflowManualStartedById',
  WorkflowTriggerId = 'workflowTriggerId',
  WorkflowTriggerTaskInstanceId = 'workflowTriggerTaskInstanceId',
  WorkflowTriggerType = 'workflowTriggerType'
}

export type AgencyMemberWorkflowTag = {
  __typename?: 'AgencyMemberWorkflowTag';
  id: Scalars['WorkflowTagId'];
  input: Scalars['String'];
  name: Scalars['String'];
};

export type AgencyMemberWorkflowTagConnection = {
  __typename?: 'AgencyMemberWorkflowTagConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTag>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowTag_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowTagId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowTag__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTag__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTag__OrderField {
  Id = 'id',
  Name = 'name'
}

export type AgencyMemberWorkflowTaskDefinition = {
  __typename?: 'AgencyMemberWorkflowTaskDefinition';
  assignmentTimeoutSeconds: Maybe<Scalars['Int']>;
  children: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  error_handlers: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mandatory: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Maybe<Scalars['Int']>;
  severity: Maybe<Scalars['String']>;
  type: Scalars['String'];
  workflowDefinition: AgencyMemberWorkflowDefinition;
  workflowDefinitionId: Scalars['WorkflowDefinitionId'];
};

export type AgencyMemberWorkflowTaskDefinitionConnection = {
  __typename?: 'AgencyMemberWorkflowTaskDefinitionConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskDefinition>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowTaskDefinition_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<String_Filter>;
  /** Filter based on "mandatory" field */
  mandatory?: InputMaybe<Boolean_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "priority" field */
  priority?: InputMaybe<Int_Filter>;
  /** Filter based on "severity" field */
  severity?: InputMaybe<String_Filter>;
  /** Filter based on "type" field */
  type?: InputMaybe<String_Filter>;
  /** Filter based on "workflowDefinitionId" field */
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
};

export type AgencyMemberWorkflowTaskDefinition__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskDefinition__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskDefinition__OrderField {
  Id = 'id',
  Mandatory = 'mandatory',
  Name = 'name',
  Priority = 'priority',
  Severity = 'severity',
  Type = 'type',
  WorkflowDefinitionId = 'workflowDefinitionId'
}

export type AgencyMemberWorkflowTaskInstance = {
  __typename?: 'AgencyMemberWorkflowTaskInstance';
  clusterId: Maybe<Scalars['WorkflowTaskClusterId']>;
  clusterValue: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['Instant']>;
  completedBy: Maybe<AgencyMemberAgencyMember>;
  completedById: Maybe<Scalars['AgencyMemberId']>;
  createdAt: Scalars['Instant'];
  id: Scalars['WorkflowTaskInstanceId'];
  input: AgencyMemberWorkflowTaskInstanceInputConnection;
  priority: Maybe<Scalars['Int']>;
  retryCount: Scalars['Int'];
  severity: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
  systemTaskId: Maybe<Scalars['String']>;
  systemTaskVersion: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  workflowDefinitionId: Scalars['WorkflowDefinitionId'];
  workflowInstance: AgencyMemberWorkflowInstance;
  workflowInstanceId: Scalars['WorkflowInstanceId'];
  workflowTaskDefinition: Maybe<AgencyMemberWorkflowTaskDefinition>;
  workflowTaskDefinitionId: Scalars['String'];
  workflowTaskInstanceTags: AgencyMemberWorkflowTaskInstanceTagConnection;
};


export type AgencyMemberWorkflowTaskInstanceInputArgs = {
  entity?: InputMaybe<String_Filter>;
  fieldName?: InputMaybe<String_Filter>;
  isArray?: InputMaybe<Boolean_Filter>;
  isNullable?: InputMaybe<Boolean_Filter>;
  isOptional?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceInput__Order>>>;
  type?: InputMaybe<String_Filter>;
  value?: InputMaybe<String_Filter>;
  valueOrd?: InputMaybe<Int_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};


export type AgencyMemberWorkflowTaskInstanceWorkflowTaskInstanceTagsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceTag__Order>>>;
  tagId?: InputMaybe<WorkflowTagId_Filter>;
  tagValue?: InputMaybe<String_Filter>;
  workflowTagDefinition?: InputMaybe<AgencyMemberWorkflowTag_RelationFilter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};

export type AgencyMemberWorkflowTaskInstanceConnection = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowTaskInstanceInput = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceInput';
  entity: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  isArray: Scalars['Boolean'];
  isNullable: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  type: Scalars['String'];
  value: Maybe<Scalars['String']>;
  valueOrd: Maybe<Scalars['Int']>;
  workflowDefinitionId: Scalars['WorkflowDefinitionId'];
  workflowInstanceId: Scalars['WorkflowInstanceId'];
  workflowTaskDefinitionId: Scalars['String'];
  workflowTaskInstance: AgencyMemberWorkflowTaskInstance;
  workflowTaskInstanceId: Scalars['WorkflowTaskInstanceId'];
};

export type AgencyMemberWorkflowTaskInstanceInputConnection = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceInputConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskInstanceInput>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowTaskInstanceInput__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskInstanceInput__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskInstanceInput__OrderField {
  Entity = 'entity',
  FieldName = 'fieldName',
  IsArray = 'isArray',
  IsNullable = 'isNullable',
  IsOptional = 'isOptional',
  Type = 'type',
  Value = 'value',
  ValueOrd = 'valueOrd',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowInstanceId = 'workflowInstanceId',
  WorkflowTaskDefinitionId = 'workflowTaskDefinitionId',
  WorkflowTaskInstanceId = 'workflowTaskInstanceId'
}

export type AgencyMemberWorkflowTaskInstanceTag = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceTag';
  createdAt: Scalars['Instant'];
  tagId: Scalars['WorkflowTagId'];
  tagValue: Scalars['String'];
  workflowTagDefinition: AgencyMemberWorkflowTag;
  workflowTaskInstance: AgencyMemberWorkflowTaskInstance;
  workflowTaskInstanceId: Scalars['WorkflowTaskInstanceId'];
};

export type AgencyMemberWorkflowTaskInstanceTagConnection = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceTagConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskInstanceTag>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowTaskInstanceTag__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskInstanceTag__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskInstanceTag__OrderField {
  CreatedAt = 'createdAt',
  TagId = 'tagId',
  TagValue = 'tagValue',
  WorkflowTaskInstanceId = 'workflowTaskInstanceId'
}

export type AgencyMemberWorkflowTaskInstance_RelationFilter = {
  /** Filter based on "clusterId" field */
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  /** Filter based on "clusterValue" field */
  clusterValue?: InputMaybe<String_Filter>;
  /** Filter based on "completedAt" field */
  completedAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "completedById" field */
  completedById?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  /** Filter based on "priority" field */
  priority?: InputMaybe<Int_Filter>;
  /** Filter based on "retryCount" field */
  retryCount?: InputMaybe<Int_Filter>;
  /** Filter based on "severity" field */
  severity?: InputMaybe<String_Filter>;
  /** Filter based on "success" field */
  success?: InputMaybe<Boolean_Filter>;
  /** Filter based on "systemTaskId" field */
  systemTaskId?: InputMaybe<String_Filter>;
  /** Filter based on "systemTaskVersion" field */
  systemTaskVersion?: InputMaybe<Int_Filter>;
  /** Filter based on "type" field */
  type?: InputMaybe<String_Filter>;
  /** Filter based on "workflowDefinitionId" field */
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  /** Filter based on "workflowInstanceId" field */
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  /** Filter based on "workflowTaskDefinitionId" field */
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowTaskInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskInstance__OrderField {
  ClusterId = 'clusterId',
  ClusterValue = 'clusterValue',
  CompletedAt = 'completedAt',
  CompletedById = 'completedById',
  CreatedAt = 'createdAt',
  Id = 'id',
  Priority = 'priority',
  RetryCount = 'retryCount',
  Severity = 'severity',
  Success = 'success',
  SystemTaskId = 'systemTaskId',
  SystemTaskVersion = 'systemTaskVersion',
  Type = 'type',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowInstanceId = 'workflowInstanceId',
  WorkflowTaskDefinitionId = 'workflowTaskDefinitionId'
}

export type AgencyMemberWorkflowTaskSkill = {
  __typename?: 'AgencyMemberWorkflowTaskSkill';
  id: Scalars['WorkflowSkillId'];
  workflowTaskInstanceId: Scalars['WorkflowTaskInstanceId'];
};

export type AgencyMemberWorkflowTaskSkillConnection = {
  __typename?: 'AgencyMemberWorkflowTaskSkillConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskSkill>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyMemberWorkflowTaskSkill__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskSkill__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskSkill__OrderField {
  Id = 'id',
  WorkflowTaskInstanceId = 'workflowTaskInstanceId'
}

/** Filter result rows based on the value of a field */
export type AgencyPhonebookContactId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyPhonebookContactId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyPhonebookContactId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyPhonebookContactId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyPhonebookContactId']>>;
};

export type AgencyTeam = {
  __typename?: 'AgencyTeam';
  active: Scalars['Boolean'];
  agencyMembers: AgencyTeamAgencyMemberAssocConnection;
  id: Scalars['AgencyTeamId'];
  name: Scalars['String'];
  teamLeader: AgencyMemberAgencyMember;
  teamLeaderId: Maybe<Scalars['AgencyMemberId']>;
};


export type AgencyTeamAgencyMembersArgs = {
  agencyMember?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  agencyTeam?: InputMaybe<AgencyTeam_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AgencyTeamAgencyMemberAssoc = {
  __typename?: 'AgencyTeamAgencyMemberAssoc';
  agencyMember: AgencyMemberAgencyMember;
  agencyMemberId: Scalars['AgencyMemberId'];
  agencyTeam: AgencyTeam;
  agencyTeamId: Scalars['AgencyTeamId'];
};

export type AgencyTeamAgencyMemberAssocConnection = {
  __typename?: 'AgencyTeamAgencyMemberAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyTeamAgencyMemberAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AgencyTeamConnection = {
  __typename?: 'AgencyTeamConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyTeam>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type AgencyTeamId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyTeamId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyTeamId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyTeamId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyTeamId']>>;
};

export type AgencyTeam_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyTeamId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyTeam__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyTeam__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyTeam__OrderField {
  Active = 'active',
  Id = 'id',
  Name = 'name'
}

/** Filter result rows based on the value of a field */
export type AuthorizationId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AuthorizationId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AuthorizationId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AuthorizationId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AuthorizationId']>>;
};

export type AuthorizedPatientWithoutVisitsView = {
  __typename?: 'AuthorizedPatientWithoutVisitsView';
  patient: Patient;
  patientAuthorization: PatientAuthorization;
  patientAuthorizationId: Scalars['AuthorizationId'];
  patientId: Scalars['PatientId'];
};

export type AuthorizedPatientWithoutVisitsViewConnection = {
  __typename?: 'AuthorizedPatientWithoutVisitsViewConnection';
  /** The nodes that match the query */
  nodes: Array<AuthorizedPatientWithoutVisitsView>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type AuthorizedPatientWithoutVisitsView__Order = {
  /** Field to order by */
  field?: InputMaybe<AuthorizedPatientWithoutVisitsView__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AuthorizedPatientWithoutVisitsView__OrderField {
  EndDate = 'endDate',
  PatientAuthorizationId = 'patientAuthorizationId',
  PatientId = 'patientId',
  StartDate = 'startDate'
}

/** Filter result rows based on the value of a field */
export type Boolean_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['Boolean']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Filter result rows based on the value of a field */
export type CaregiverId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CaregiverId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CaregiverId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CaregiverId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CaregiverId']>>;
};

export type CaregiverOfficeAssoc = {
  __typename?: 'CaregiverOfficeAssoc';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId'];
  office: AgencyMemberOffice;
  officeId: Scalars['OfficeId'];
};

export type CaregiverOfficeAssocConnection = {
  __typename?: 'CaregiverOfficeAssocConnection';
  /** The nodes that match the query */
  nodes: Array<CaregiverOfficeAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type CaregiverVisitEngagementId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CaregiverVisitEngagementId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CaregiverVisitEngagementId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CaregiverVisitEngagementId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CaregiverVisitEngagementId']>>;
};

export type CommCenterLabel = {
  __typename?: 'CommCenterLabel';
  _priority: Scalars['String'];
  active: Scalars['Boolean'];
  assignedTeam: CommCenterTeam;
  assignedTeamId: Scalars['CommCenterTeamId'];
  code: Maybe<Scalars['String']>;
  displayToAgencyMember: Scalars['Boolean'];
  displayToCaregiver: Scalars['Boolean'];
  iconUrl: Maybe<Scalars['String']>;
  id: Scalars['CommCenterLabelId'];
  messageActionId: Maybe<Scalars['CommCenterMessageActionId']>;
  name: Scalars['String'];
  parent: Maybe<CommCenterLabel>;
  parentId: Maybe<Scalars['CommCenterLabelId']>;
  priority: CommCenterLabelPriority;
  timeToResolve: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type CommCenterLabelId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterLabelId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterLabelId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterLabelId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterLabelId']>>;
};

export enum CommCenterLabelPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CommCenterLabel_RelationFilter = {
  /** Filter based on "_priority" field */
  _priority?: InputMaybe<String_Filter>;
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "assignedTeamId" field */
  assignedTeamId?: InputMaybe<CommCenterTeamId_Filter>;
  /** Filter based on "code" field */
  code?: InputMaybe<String_Filter>;
  /** Filter based on "displayToAgencyMember" field */
  displayToAgencyMember?: InputMaybe<Boolean_Filter>;
  /** Filter based on "displayToCaregiver" field */
  displayToCaregiver?: InputMaybe<Boolean_Filter>;
  /** Filter based on "iconUrl" field */
  iconUrl?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "messageActionId" field */
  messageActionId?: InputMaybe<CommCenterMessageActionId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "parentId" field */
  parentId?: InputMaybe<CommCenterLabelId_Filter>;
  priority?: InputMaybe<Array<CommCenterLabelPriority>>;
  /** Filter based on "timeToResolve" field */
  timeToResolve?: InputMaybe<Int_Filter>;
};

/** Filter result rows based on the value of a field */
export type CommCenterMessageActionId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterMessageActionId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterMessageActionId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterMessageActionId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterMessageActionId']>>;
};

export type CommCenterTeam = {
  __typename?: 'CommCenterTeam';
  active: Scalars['Boolean'];
  id: Scalars['CommCenterTeamId'];
  name: Scalars['String'];
};

/** Filter result rows based on the value of a field */
export type CommCenterTeamId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterTeamId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterTeamId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterTeamId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterTeamId']>>;
};

export type CommCenterTeam_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CommCenterTeamId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type CommCenterTicket = {
  __typename?: 'CommCenterTicket';
  _priority: Scalars['String'];
  _source: Scalars['String'];
  _topic: Scalars['String'];
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  createdAt: Scalars['Instant'];
  createdBy: Scalars['UserId'];
  createdBySystem: Scalars['Boolean'];
  enableAgencyResponse: Scalars['Boolean'];
  id: Scalars['CommCenterTicketId'];
  label: CommCenterLabel;
  labelId: Scalars['CommCenterLabelId'];
  patient: Maybe<Patient>;
  patientId: Maybe<Scalars['PatientId']>;
  phoneNumber: Maybe<Scalars['String']>;
  phonebookContact: Maybe<PhonebookContact>;
  phonebookContactId: Maybe<Scalars['AgencyPhonebookContactId']>;
  priority: CommCenterLabelPriority;
  relatedVisitBroadcastId: Maybe<Scalars['VisitBroadcastId']>;
  relatedVisitInstanceId: Maybe<Scalars['VisitInstanceId']>;
  source: CommCenterTicketSource;
  team: CommCenterTeam;
  teamId: Scalars['CommCenterTeamId'];
  topic: CommCenterTicketTopic;
  unreadCount: Scalars['Int'];
  visitBroadcast: Maybe<AgencyMemberVisitBroadcast>;
  visitInstance: Maybe<AgencyMemberVisitInstance>;
};

export type CommCenterTicketConnection = {
  __typename?: 'CommCenterTicketConnection';
  /** The nodes that match the query */
  nodes: Array<CommCenterTicket>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type CommCenterTicketId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterTicketId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterTicketId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterTicketId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterTicketId']>>;
};

export enum CommCenterTicketSource {
  Email = 'EMAIL',
  Manual = 'MANUAL',
  MobileChat = 'MOBILE_CHAT',
  PhoneCall = 'PHONE_CALL',
  SmsConversation = 'SMS_CONVERSATION',
  SystemTrigger = 'SYSTEM_TRIGGER'
}

export enum CommCenterTicketTopic {
  BotAgent = 'BotAgent',
  Caregiver = 'Caregiver',
  NotIdentifiedEmailEntity = 'NotIdentifiedEmailEntity',
  NotIdentifiedPhoneNumber = 'NotIdentifiedPhoneNumber',
  Patient = 'Patient',
  PhonebookContact = 'PhonebookContact'
}

export type CommCenterTicket_RelationFilter = {
  /** Filter based on "_priority" field */
  _priority?: InputMaybe<String_Filter>;
  /** Filter based on "_source" field */
  _source?: InputMaybe<String_Filter>;
  /** Filter based on "_topic" field */
  _topic?: InputMaybe<String_Filter>;
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "createdBy" field */
  createdBy?: InputMaybe<UserId_Filter>;
  /** Filter based on "createdBySystem" field */
  createdBySystem?: InputMaybe<Boolean_Filter>;
  /** Filter based on "enableAgencyResponse" field */
  enableAgencyResponse?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CommCenterTicketId_Filter>;
  /** Filter based on "labelId" field */
  labelId?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  /** Filter based on "phoneNumber" field */
  phoneNumber?: InputMaybe<String_Filter>;
  /** Filter based on "phonebookContactId" field */
  phonebookContactId?: InputMaybe<AgencyPhonebookContactId_Filter>;
  priority?: InputMaybe<Array<CommCenterLabelPriority>>;
  /** Filter based on "relatedVisitBroadcastId" field */
  relatedVisitBroadcastId?: InputMaybe<VisitBroadcastId_Filter>;
  /** Filter based on "relatedVisitInstanceId" field */
  relatedVisitInstanceId?: InputMaybe<VisitInstanceId_Filter>;
  source?: InputMaybe<Array<CommCenterTicketSource>>;
  /** Filter based on "teamId" field */
  teamId?: InputMaybe<CommCenterTeamId_Filter>;
  topic?: InputMaybe<Array<CommCenterTicketTopic>>;
};

export type CommCenterTicket__Order = {
  /** Field to order by */
  field?: InputMaybe<CommCenterTicket__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum CommCenterTicket__OrderField {
  Priority = '_priority',
  Source = '_source',
  Topic = '_topic',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  CreatedBySystem = 'createdBySystem',
  EnableAgencyResponse = 'enableAgencyResponse',
  Id = 'id',
  LabelId = 'labelId',
  PatientId = 'patientId',
  PhoneNumber = 'phoneNumber',
  PhonebookContactId = 'phonebookContactId',
  RelatedVisitBroadcastId = 'relatedVisitBroadcastId',
  RelatedVisitInstanceId = 'relatedVisitInstanceId',
  TeamId = 'teamId'
}

export type ContractType = {
  __typename?: 'ContractType';
  active: Scalars['Boolean'];
  id: Scalars['ContractTypeId'];
  name: Scalars['String'];
};

export type ContractTypeConnection = {
  __typename?: 'ContractTypeConnection';
  /** The nodes that match the query */
  nodes: Array<ContractType>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type ContractTypeId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ContractTypeId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ContractTypeId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ContractTypeId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ContractTypeId']>>;
};

export type ContractType_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<ContractTypeId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type ContractType__Order = {
  /** Field to order by */
  field?: InputMaybe<ContractType__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum ContractType__OrderField {
  Active = 'active',
  Id = 'id',
  Name = 'name'
}

/** Filter result rows based on the value of a field */
export type ImportedVisitId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ImportedVisitId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ImportedVisitId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ImportedVisitId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ImportedVisitId']>>;
};

/** Filter result rows based on the value of a field */
export type Instant_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['Instant']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['Instant']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['Instant']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['Instant']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['Instant']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['Instant']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['Instant']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['Instant']>>;
};

/** Filter result rows based on the value of a field */
export type Int_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['Int']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['Int']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['Int']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['Int']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['Int']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['Int']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Filter result rows based on the value of a field */
export type LocalDateTime_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['LocalDateTime']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['LocalDateTime']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['LocalDateTime']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['LocalDateTime']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['LocalDateTime']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['LocalDateTime']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['LocalDateTime']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['LocalDateTime']>>;
};

/** Filter result rows based on the value of a field */
export type LocalDate_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['LocalDate']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['LocalDate']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['LocalDate']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['LocalDate']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['LocalDate']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['LocalDate']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['LocalDate']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['LocalDate']>>;
};

/** Filter result rows based on the value of a field */
export type MedflytChrcDataId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['MedflytCHRCDataId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['MedflytCHRCDataId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['MedflytCHRCDataId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['MedflytCHRCDataId']>>;
};

/** Filter result rows based on the value of a field */
export type MedflytHcrDataId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['MedflytHCRDataId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['MedflytHCRDataId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['MedflytHCRDataId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['MedflytHCRDataId']>>;
};

export type Note = {
  __typename?: 'Note';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId'];
  createdAt: Scalars['Instant'];
  id: Scalars['NoteId'];
  noteRichText: Scalars['String'];
  patient: Patient;
  patientId: Scalars['PatientId'];
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  /** The nodes that match the query */
  nodes: Array<Note>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type NoteId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['NoteId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['NoteId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['NoteId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['NoteId']>>;
};

export type Note_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<NoteId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
};

export type Note__Order = {
  /** Field to order by */
  field?: InputMaybe<Note__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum Note__OrderField {
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PatientId = 'patientId'
}

/** Filter result rows based on the value of a field */
export type OfficeId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['OfficeId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['OfficeId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['OfficeId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['OfficeId']>>;
};

export type Patient = {
  __typename?: 'Patient';
  active: Scalars['Boolean'];
  activeContracts: PatientActiveContractsConnection;
  additionalAddresses: PatientAdditionalAddressesConnection;
  address: Maybe<Scalars['String']>;
  agencyBranches: AgencyBranchPatientAssocConnection;
  agencyTeam: Maybe<AgencyTeam>;
  agencyTeamId: Maybe<Scalars['AgencyTeamId']>;
  assignedCoordinator: Maybe<AgencyMemberAgencyMember>;
  assignedCoordinatorId: Maybe<Scalars['AgencyMemberId']>;
  authorizations: PatientAuthorizationConnection;
  createdAt: Scalars['Instant'];
  createdBy: AgencyMemberAgencyMember;
  createdById: Scalars['AgencyMemberId'];
  currentOffice: AgencyMemberOffice;
  currentOfficeId: Scalars['OfficeId'];
  customFields: Scalars['EntityCustomField'];
  dateOfBirth: Maybe<Scalars['LocalDate']>;
  displayId: Maybe<Scalars['Int']>;
  effectiveDate: Maybe<Scalars['LocalDate']>;
  firstName: Scalars['String'];
  firstStartOfCare: Maybe<PatientCertificationPeriod>;
  firstStartOfCareCertificationPeriodId: Maybe<Scalars['CertificationPeriodId']>;
  gender: Maybe<Scalars['PatientGender']>;
  hasEmergencyKardexInfo: Scalars['Boolean'];
  hasPhysicianInfo: Scalars['Boolean'];
  homePhoneNumber: Maybe<Scalars['String']>;
  id: Scalars['PatientId'];
  lastName: Scalars['String'];
  lastReassessment: Maybe<PatientCertificationPeriod>;
  lastReassessmentCertificationPeriodId: Maybe<Scalars['CertificationPeriodId']>;
  lastStartOfCare: Maybe<PatientCertificationPeriod>;
  lastStartOfCareCertificationPeriodId: Maybe<Scalars['CertificationPeriodId']>;
  middleName: Maybe<Scalars['String']>;
  mobilePhoneNumber: Maybe<Scalars['String']>;
  nextReassessment: Maybe<PatientCertificationPeriod>;
  nextReassessmentCertificationPeriodId: Maybe<Scalars['CertificationPeriodId']>;
  phoneNumbers: PatientPhoneNumberConnection;
  primaryAddress: PatientPrimaryAddress;
  /** Social Security Number */
  ssn: Maybe<Scalars['String']>;
  startOfCare: Maybe<Scalars['LocalDate']>;
  status: Scalars['PatientStatus'];
  visitInstances: AgencyMemberVisitInstanceConnection;
};


export type PatientActiveContractsArgs = {
  contractType?: InputMaybe<ContractType_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
};


export type PatientAdditionalAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PatientAgencyBranchesArgs = {
  agencyBranch?: InputMaybe<AgencyBranch_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patient?: InputMaybe<Patient_RelationFilter>;
};


export type PatientAuthorizationsArgs = {
  authorizationCode?: InputMaybe<String_Filter>;
  endDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<AuthorizationId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorization__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  serviceCode?: InputMaybe<ServiceCode_RelationFilter>;
  startDate?: InputMaybe<LocalDate_Filter>;
};


export type PatientPhoneNumbersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PatientVisitInstancesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  id?: InputMaybe<VisitInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitInstance__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};

export type PatientActiveContracts = {
  __typename?: 'PatientActiveContracts';
  contractType: ContractType;
  contractTypeId: Scalars['ContractTypeId'];
  patientContract: PatientContract;
  patientContractId: Scalars['PatientContractId'];
  patientId: Scalars['PatientId'];
};

export type PatientActiveContractsConnection = {
  __typename?: 'PatientActiveContractsConnection';
  /** The nodes that match the query */
  nodes: Array<PatientActiveContracts>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PatientAdditionalAddresses = {
  __typename?: 'PatientAdditionalAddresses';
  addressLine1: Maybe<Scalars['String']>;
  addressLine2: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  county: Maybe<Scalars['String']>;
  geo: Maybe<Scalars['Geo']>;
  patientId: Scalars['PatientId'];
  state: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  zip4: Maybe<Scalars['String']>;
  zip5: Maybe<Scalars['String']>;
  zip9: Maybe<Scalars['String']>;
};

export type PatientAdditionalAddressesConnection = {
  __typename?: 'PatientAdditionalAddressesConnection';
  /** The nodes that match the query */
  nodes: Array<PatientAdditionalAddresses>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PatientAuthorization = {
  __typename?: 'PatientAuthorization';
  authorizationCode: Maybe<Scalars['String']>;
  endDate: Scalars['LocalDate'];
  id: Scalars['AuthorizationId'];
  /** NULL value means unlimited */
  maxMinutes: Maybe<Scalars['Int']>;
  patient: Patient;
  patientContract: PatientContract;
  patientId: Scalars['PatientId'];
  periodUtilizations: PatientAuthorizationPeriodUtilizationConnection;
  serviceCode: ServiceCode;
  startDate: Scalars['LocalDate'];
  timeConfig: Scalars['AuthorizationTimeConfig'];
};


export type PatientAuthorizationPeriodUtilizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  numIncorrectlyAllocatedVisits?: InputMaybe<Int_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorizationPeriodUtilization__Order>>>;
  periodOverAllocated?: InputMaybe<Boolean_Filter>;
  periodUnderUtilized?: InputMaybe<Boolean_Filter>;
};

export type PatientAuthorizationConnection = {
  __typename?: 'PatientAuthorizationConnection';
  /** The nodes that match the query */
  nodes: Array<PatientAuthorization>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PatientAuthorizationPeriodUtilization = {
  __typename?: 'PatientAuthorizationPeriodUtilization';
  /** running total of the allocated minutes (chronologically) (including this period) */
  minutesAllocatedInAuthorization: Scalars['Int'];
  /** total minutes actually allocated in this period (simple sum over visit_allocation) */
  minutesAllocatedInPeriod: Scalars['Int'];
  /** total minutes available in this period (doesn't look at actual allocations) */
  minutesAvailableInPeriod: Scalars['Int'];
  /** remaining based on running total */
  minutesRemainingInAuthorization: Scalars['Int'];
  /** minutes_available_in_period - minutes_allocated_in_period */
  minutesRemainingInPeriod: Scalars['Int'];
  /** number of visits within this period that potentially match this authorization and have an incorrectly allocated amount. If greater than 0 then this period should be flagged. */
  numIncorrectlyAllocatedVisits: Scalars['Int'];
  /** DATE of last day of period */
  periodEnd: Scalars['LocalDate'];
  /** period is over-allocated */
  periodOverAllocated: Scalars['Boolean'];
  /** DATE of first day of period */
  periodStart: Scalars['LocalDate'];
  /** minutes_remaining_in_period > 0 */
  periodUnderUtilized: Scalars['Boolean'];
  /** TODO ??? */
  totalAuthorizationMinutesFree: Scalars['Int'];
  /** TODO ??? */
  totalAuthorizationMinutesUsed: Scalars['Int'];
};

export type PatientAuthorizationPeriodUtilizationConnection = {
  __typename?: 'PatientAuthorizationPeriodUtilizationConnection';
  /** The nodes that match the query */
  nodes: Array<PatientAuthorizationPeriodUtilization>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PatientAuthorizationPeriodUtilization__Order = {
  /** Field to order by */
  field?: InputMaybe<PatientAuthorizationPeriodUtilization__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PatientAuthorizationPeriodUtilization__OrderField {
  /** number of visits within this period that potentially match this authorization and have an incorrectly allocated amount. If greater than 0 then this period should be flagged. */
  NumIncorrectlyAllocatedVisits = 'numIncorrectlyAllocatedVisits',
  /** period is over-allocated */
  PeriodOverAllocated = 'periodOverAllocated',
  /** minutes_remaining_in_period > 0 */
  PeriodUnderUtilized = 'periodUnderUtilized'
}

export type PatientAuthorization_RelationFilter = {
  /** Filter based on "authorizationCode" field */
  authorizationCode?: InputMaybe<String_Filter>;
  /** Filter based on "endDate" field */
  endDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AuthorizationId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  /** Filter based on "startDate" field */
  startDate?: InputMaybe<LocalDate_Filter>;
};

export type PatientAuthorization__Order = {
  /** Field to order by */
  field?: InputMaybe<PatientAuthorization__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PatientAuthorization__OrderField {
  AuthorizationCode = 'authorizationCode',
  EndDate = 'endDate',
  Id = 'id',
  PatientId = 'patientId',
  StartDate = 'startDate'
}

export type PatientCertificationPeriod = {
  __typename?: 'PatientCertificationPeriod';
  containsRunDate: Scalars['Boolean'];
  daysFromEndDate: Scalars['Int'];
  daysFromStartDate: Scalars['Int'];
  documents: Scalars['Int'];
  endDate: Scalars['LocalDate'];
  hasActiveTaskInstance: Scalars['Boolean'];
  id: Scalars['CertificationPeriodId'];
  isCompleted: Scalars['Boolean'];
  latestTaskInstance: Maybe<PatientTaskInstance>;
  latestTaskInstanceId: Maybe<Scalars['PatientTaskInstanceId']>;
  patient: Patient;
  patientId: Scalars['PatientId'];
  patientTask: Maybe<PatientTask>;
  startDate: Scalars['LocalDate'];
  submitted: Scalars['Int'];
  type: Scalars['String'];
};

export type PatientConnection = {
  __typename?: 'PatientConnection';
  /** The nodes that match the query */
  nodes: Array<Patient>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PatientContract = {
  __typename?: 'PatientContract';
  contractType: ContractType;
  contractTypeId: Scalars['ContractTypeId'];
  endDate: Maybe<Scalars['LocalDate']>;
  id: Scalars['PatientContractId'];
  medicaidNumber: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
};

export type PatientContract_RelationFilter = {
  /** Filter based on "endDate" field */
  endDate?: InputMaybe<LocalDate_Filter>;
};

export type PatientCustomFields = {
  __typename?: 'PatientCustomFields';
  customField: Scalars['String'];
};

export type PatientCustomFieldsConnection = {
  __typename?: 'PatientCustomFieldsConnection';
  /** The nodes that match the query */
  nodes: Array<PatientCustomFields>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type PatientId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientId']>>;
};

export type PatientIssue = {
  __typename?: 'PatientIssue';
  _severity: Scalars['String'];
  _status: Scalars['String'];
  _tags: Maybe<Array<Maybe<Scalars['String']>>>;
  _type: Scalars['String'];
  assignedAgencyMemberId: Scalars['AgencyMemberId'];
  assigned_agency_member: Maybe<AgencyMemberAgencyMember>;
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  createdAt: Scalars['Instant'];
  description: Scalars['String'];
  id: Scalars['PatientIssueId'];
  patient: Patient;
  patientId: Scalars['PatientId'];
  resolutionDescription: Maybe<Scalars['String']>;
  resulttedAt: Maybe<Scalars['Instant']>;
  resulttedBy: Maybe<Scalars['AgencyMemberId']>;
  resultted_by: Maybe<AgencyMemberAgencyMember>;
  severity: PatientIssueSeverity;
  sourceTicketId: Scalars['CommCenterTicketId'];
  status: PatientIssueStatus;
  tags: Maybe<Array<PatientIssueTag>>;
  type: PatientIssueType;
};

export type PatientIssueConnection = {
  __typename?: 'PatientIssueConnection';
  /** The nodes that match the query */
  nodes: Array<PatientIssue>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type PatientIssueId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientIssueId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientIssueId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientIssueId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientIssueId']>>;
};

export enum PatientIssueSeverity {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum PatientIssueStatus {
  InProgress = 'In_Progress',
  NotRelevant = 'Not_Relevant',
  Open = 'Open',
  Resolved = 'Resolved'
}

export enum PatientIssueTag {
  Hr = 'HR',
  NotifyMltc = 'Notify_MLTC',
  Nursing = 'Nursing',
  Retention = 'Retention',
  Staffing = 'Staffing'
}

export enum PatientIssueType {
  Complaint = 'Complaint',
  Incident = 'Incident'
}

export type PatientIssue__Order = {
  /** Field to order by */
  field?: InputMaybe<PatientIssue__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PatientIssue__OrderField {
  Severity = '_severity',
  Status = '_status',
  Tags = '_tags',
  Type = '_type',
  AssignedAgencyMemberId = 'assignedAgencyMemberId',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  PatientId = 'patientId',
  ResolutionDescription = 'resolutionDescription',
  ResulttedAt = 'resulttedAt',
  ResulttedBy = 'resulttedBy',
  SourceTicketId = 'sourceTicketId'
}

export type PatientPhoneNumber = {
  __typename?: 'PatientPhoneNumber';
  description: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  patientId: Scalars['PatientId'];
  phonenumber: Scalars['String'];
  type: Scalars['String'];
};

export type PatientPhoneNumberConnection = {
  __typename?: 'PatientPhoneNumberConnection';
  /** The nodes that match the query */
  nodes: Array<PatientPhoneNumber>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PatientPrimaryAddress = {
  __typename?: 'PatientPrimaryAddress';
  addressLine1: Maybe<Scalars['String']>;
  addressLine2: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  county: Scalars['String'];
  geo: Maybe<Scalars['Geo']>;
  patientId: Scalars['PatientId'];
  state: Scalars['String'];
  timezone: Scalars['String'];
  zip4: Maybe<Scalars['String']>;
  zip5: Maybe<Scalars['String']>;
  zip9: Maybe<Scalars['String']>;
};

export enum PatientQualifiedLeadReason {
  QualifiedManually = 'QualifiedManually',
  QualifiedStatusWithIntakeCall = 'QualifiedStatusWithIntakeCall',
  QualifiedStatusWithMaxAge = 'QualifiedStatusWithMaxAge',
  QualifiedStatusWithMedicaid = 'QualifiedStatusWithMedicaid'
}

export type PatientTask = {
  __typename?: 'PatientTask';
  caregiverId: Maybe<Scalars['CaregiverId']>;
  certificationPeriodId: Maybe<Scalars['CertificationPeriodId']>;
  daysFromDueDate: Scalars['Int'];
  daysFromStartDate: Scalars['Int'];
  dueDate: Scalars['LocalDate'];
  id: Scalars['PatientTaskId'];
  isCanceled: Scalars['Boolean'];
  isDraft: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
  patientId: Scalars['PatientId'];
  repeatMonths: Maybe<Scalars['Int']>;
  startDate: Scalars['LocalDate'];
  taskInstance: PatientTaskInstanceConnection;
  title: Scalars['String'];
};


export type PatientTaskTaskInstanceArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PatientTaskInstance = {
  __typename?: 'PatientTaskInstance';
  completionDate: Maybe<Scalars['LocalDate']>;
  daysFromDueDate: Scalars['Int'];
  daysFromStartDate: Scalars['Int'];
  dueDate: Scalars['LocalDate'];
  durationMinutes: Scalars['Int'];
  id: Scalars['PatientTaskInstanceId'];
  isCanceled: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
  startDate: Scalars['LocalDate'];
  taskId: Scalars['PatientTaskId'];
};

export type PatientTaskInstanceConnection = {
  __typename?: 'PatientTaskInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<PatientTaskInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type PatientWebsiteVisitorEventId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientWebsiteVisitorEventId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientWebsiteVisitorEventId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientWebsiteVisitorEventId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientWebsiteVisitorEventId']>>;
};

/** Filter result rows based on the value of a field */
export type PatientWebsiteVisitorId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientWebsiteVisitorId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientWebsiteVisitorId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientWebsiteVisitorId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientWebsiteVisitorId']>>;
};

/** Filter result rows based on the value of a field */
export type PatientWebsiteVisitorVisitId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientWebsiteVisitorVisitId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientWebsiteVisitorVisitId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientWebsiteVisitorVisitId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientWebsiteVisitorVisitId']>>;
};

export type Patient_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  addressSearch?: InputMaybe<Scalars['String']>;
  agencyBranchId?: InputMaybe<Array<Scalars['AgencyBranchId']>>;
  /** Filter based on "agencyTeamId" field */
  agencyTeamId?: InputMaybe<AgencyTeamId_Filter>;
  /** Filter based on "assignedCoordinatorId" field */
  assignedCoordinatorId?: InputMaybe<AgencyMemberId_Filter>;
  contractTypeId?: InputMaybe<Array<Scalars['ContractTypeId']>>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "createdById" field */
  createdById?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "currentOfficeId" field */
  currentOfficeId?: InputMaybe<OfficeId_Filter>;
  /** Filter based on "displayId" field */
  displayId?: InputMaybe<Int_Filter>;
  displayIdSearch?: InputMaybe<Scalars['String']>;
  /** Filter based on "effectiveDate" field */
  effectiveDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "firstName" field */
  firstName?: InputMaybe<String_Filter>;
  firstNameSearch?: InputMaybe<Scalars['String']>;
  /** Filter based on "hasEmergencyKardexInfo" field */
  hasEmergencyKardexInfo?: InputMaybe<Boolean_Filter>;
  /** Filter based on "hasPhysicianInfo" field */
  hasPhysicianInfo?: InputMaybe<Boolean_Filter>;
  homePhoneSearch?: InputMaybe<Scalars['String']>;
  /** Filter based on "id" field */
  id?: InputMaybe<PatientId_Filter>;
  /** Filter based on "lastName" field */
  lastName?: InputMaybe<String_Filter>;
  lastNameSearch?: InputMaybe<Scalars['String']>;
  mobilePhoneSearch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  /** Filter based on "ssn" field */
  ssn?: InputMaybe<String_Filter>;
  /** Filter based on "startOfCare" field */
  startOfCare?: InputMaybe<LocalDate_Filter>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type Patient__Order = {
  /** Field to order by */
  field?: InputMaybe<Patient__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum Patient__OrderField {
  Active = 'active',
  Address = 'address',
  AgencyTeamId = 'agencyTeamId',
  AssignedCoordinatorId = 'assignedCoordinatorId',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  CurrentOfficeId = 'currentOfficeId',
  DateOfBirth = 'dateOfBirth',
  DisplayId = 'displayId',
  EffectiveDate = 'effectiveDate',
  FirstName = 'firstName',
  HasEmergencyKardexInfo = 'hasEmergencyKardexInfo',
  HasPhysicianInfo = 'hasPhysicianInfo',
  Id = 'id',
  LastName = 'lastName',
  /** Social Security Number */
  Ssn = 'ssn',
  StartOfCare = 'startOfCare',
  StatusHidden = 'statusHidden'
}

/** Filter result rows based on the value of a field */
export type PayerId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PayerId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PayerId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PayerId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PayerId']>>;
};

export type PhonebookContact = {
  __typename?: 'PhonebookContact';
  destinationNumberType: Scalars['String'];
  id: Scalars['AgencyPhonebookContactId'];
  inboundCommCenterLabel: CommCenterLabel;
  inboundCommCenterLabelId: Scalars['CommCenterLabelId'];
  name: Scalars['String'];
  outboundCommCenterLabel: CommCenterLabel;
  outboundCommCenterLabelId: Scalars['CommCenterLabelId'];
  payerId: Maybe<Scalars['PayerId']>;
  phoneNumber: Scalars['String'];
  phonebookContactType: Maybe<Scalars['String']>;
};

export type PhonebookContactConnection = {
  __typename?: 'PhonebookContactConnection';
  /** The nodes that match the query */
  nodes: Array<PhonebookContact>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type PhonebookContact_RelationFilter = {
  /** Filter based on "destinationNumberType" field */
  destinationNumberType?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyPhonebookContactId_Filter>;
  /** Filter based on "inboundCommCenterLabelId" field */
  inboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "outboundCommCenterLabelId" field */
  outboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "payerId" field */
  payerId?: InputMaybe<PayerId_Filter>;
  /** Filter based on "phoneNumber" field */
  phoneNumber?: InputMaybe<String_Filter>;
  /** Filter based on "phonebookContactType" field */
  phonebookContactType?: InputMaybe<String_Filter>;
};

export type PhonebookContact__Order = {
  /** Field to order by */
  field?: InputMaybe<PhonebookContact__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PhonebookContact__OrderField {
  DestinationNumberType = 'destinationNumberType',
  Id = 'id',
  InboundCommCenterLabelId = 'inboundCommCenterLabelId',
  Name = 'name',
  OutboundCommCenterLabelId = 'outboundCommCenterLabelId',
  PayerId = 'payerId',
  PhoneNumber = 'phoneNumber',
  PhonebookContactType = 'phonebookContactType'
}

export type Query = {
  __typename?: 'Query';
  /** All of Agencies that the AgencyMember can see */
  agencies: AgencyMemberAgencyConnection;
  agencyBranches: AgencyBranchConnection;
  /** All of the agency members */
  agencyMembers: AgencyMemberAgencyMemberConnection;
  agencyTeams: AgencyTeamConnection;
  /** authorized_patients_without_visits sql view */
  authorizedPatientsWithoutVisits: AuthorizedPatientWithoutVisitsViewConnection;
  /** All of Caregivers that the AgencyMember can see */
  caregivers: AgencyMemberCaregiverConnection;
  /** Caregivers and their respective CHRC compliance */
  caregiversChrcCompliance: AgencyMemberCaregiverChrcComplianceConnection;
  /** Caregivers and their respective HCR compliance */
  caregiversHcrCompliance: AgencyMemberCaregiverHcrComplianceConnection;
  /** The agency's state compliance regarding caregivers and CHRC/HCR */
  caregiversStateComplianceIssues: AgencyMemberCaregiverStateComplianceConnection;
  contractTypes: ContractTypeConnection;
  /** All of VisitInstances that the AgencyMember can see */
  importedVisits: AgencyMemberImportedVisitConnection;
  notes: NoteConnection;
  /** All of Offices the AgencyMember can see */
  offices: AgencyMemberOfficeConnection;
  /** All of PatientAuthorizations that the AgencyMember can see */
  patientAuthorizations: PatientAuthorizationConnection;
  /** All of Patient Custom Fields that are used by an Agency */
  patientCustomFields: PatientCustomFieldsConnection;
  /** All of PatientIssues that the AgencyMember can see */
  patientIssues: PatientIssueConnection;
  /** Patient lead qualifications */
  patientLeadQualifications: AgencyMemberPatientLeadQualificationsConnection;
  /** Patient website visitor event */
  patientWebsiteVisitorEvents: AgencyMemberPatientWebsiteVisitorEventConnection;
  /** Patient website visitor visit */
  patientWebsiteVisitorVisits: AgencyMemberPatientWebsiteVisitorVisitConnection;
  /** Patient website visitor */
  patientWebsiteVisitors: AgencyMemberPatientWebsiteVisitorConnection;
  /** All of Patients that the AgencyMember can see */
  patients: PatientConnection;
  /** phonebook contacts */
  phonebookContacts: PhonebookContactConnection;
  /** All of ReferralUsers that the AgencyMember can see */
  referralUsers: ReferralUserConnection;
  /** comm center tickets */
  tickets: CommCenterTicketConnection;
  visitAssignments: VisitAssignmentConnection;
  visitAssignmentsDistinct: VisitAssignmentDistinctConnection;
  /** All of VisitBroadcasts that the AgencyMember can see */
  visitBroadcasts: AgencyMemberVisitBroadcastConnection;
  /** All of VisitInstances that the AgencyMember can see */
  visitInstances: AgencyMemberVisitInstanceConnection;
  /** All of the AvailableWorkflowTaskInstance that the AgencyMember can see */
  workflowAvailableTaskInstances: AgencyMemberAvailableWorkflowTaskInstanceConnection;
  /** All of WorkflowDefinitions that the AgencyMember can see */
  workflowDefinitions: AgencyMemberWorkflowDefinitionConnection;
  /** All of WorkflowInstances that the AgencyMember can see */
  workflowInstances: AgencyMemberWorkflowInstanceConnection;
  /** Workflow tags */
  workflowTags: AgencyMemberWorkflowTagConnection;
  /** Workflow task definition fields */
  workflowTaskDefinitions: AgencyMemberWorkflowTaskDefinitionConnection;
  /** Workflow task instance input fields */
  workflowTaskInstanceInputs: AgencyMemberWorkflowTaskInstanceInputConnection;
  /** Workflow task instance tags */
  workflowTaskInstanceTags: AgencyMemberWorkflowTaskInstanceTagConnection;
  /** Workflow task instances */
  workflowTaskInstances: AgencyMemberWorkflowTaskInstanceConnection;
};


export type QueryAgenciesArgs = {
  id?: InputMaybe<AgencyId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberAgency__Order>>>;
};


export type QueryAgencyBranchesArgs = {
  id?: InputMaybe<AgencyBranchId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyBranch__Order>>>;
};


export type QueryAgencyMembersArgs = {
  agency?: InputMaybe<AgencyMemberAgency_RelationFilter>;
  agencyId?: InputMaybe<AgencyId_Filter>;
  id?: InputMaybe<AgencyMemberId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  nameSearch?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberAgencyMember__Order>>>;
};


export type QueryAgencyTeamsArgs = {
  active?: InputMaybe<Boolean_Filter>;
  id?: InputMaybe<AgencyTeamId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyTeam__Order>>>;
  teamLeader?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
};


export type QueryAuthorizedPatientsWithoutVisitsArgs = {
  endDate?: InputMaybe<LocalDate_Filter>;
  from?: InputMaybe<Scalars['LocalDate']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AuthorizedPatientWithoutVisitsView__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientAuthorization?: InputMaybe<PatientAuthorization_RelationFilter>;
  patientAuthorizationId?: InputMaybe<AuthorizationId_Filter>;
  patientId?: InputMaybe<PatientId_Filter>;
  startDate?: InputMaybe<LocalDate_Filter>;
  to?: InputMaybe<Scalars['LocalDate']>;
};


export type QueryCaregiversArgs = {
  chrcCompliance?: InputMaybe<AgencyMemberCaregiverChrcCompliance_RelationFilter>;
  createdAt?: InputMaybe<Instant_Filter>;
  firstName?: InputMaybe<String_Filter>;
  hcrCompliance?: InputMaybe<AgencyMemberCaregiverHcrCompliance_RelationFilter>;
  id?: InputMaybe<CaregiverId_Filter>;
  lastName?: InputMaybe<String_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  nameSearch?: InputMaybe<Scalars['Instant']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiver__Order>>>;
};


export type QueryCaregiversChrcComplianceArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  chrcDateOfBirth?: InputMaybe<LocalDate_Filter>;
  chrcEmployeeName?: InputMaybe<String_Filter>;
  chrcStartDate?: InputMaybe<LocalDate_Filter>;
  chrcStatus?: InputMaybe<String_Filter>;
  chrcStatusDate?: InputMaybe<LocalDate_Filter>;
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromChrcStartDate?: InputMaybe<Scalars['LocalDate']>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']>;
  hireDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<MedflytChrcDataId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiverChrcCompliance__Order>>>;
  search?: InputMaybe<Scalars['String']>;
  stateRegistryNum?: InputMaybe<Int_Filter>;
  status?: InputMaybe<String_Filter>;
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toChrcStartDate?: InputMaybe<Scalars['LocalDate']>;
  toHireDate?: InputMaybe<Scalars['LocalDate']>;
};


export type QueryCaregiversHcrComplianceArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']>;
  hcrCertificateType?: InputMaybe<String_Filter>;
  hcrDateOfBirth?: InputMaybe<LocalDate_Filter>;
  hcrFullName?: InputMaybe<String_Filter>;
  hcrHireDate?: InputMaybe<LocalDate_Filter>;
  hcrSeparationDate?: InputMaybe<LocalDate_Filter>;
  hcrStateRegistryNumber?: InputMaybe<Int_Filter>;
  hireDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<MedflytHcrDataId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiverHcrCompliance__Order>>>;
  search?: InputMaybe<Scalars['String']>;
  stateRegistryNum?: InputMaybe<Int_Filter>;
  status?: InputMaybe<String_Filter>;
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toHireDate?: InputMaybe<Scalars['LocalDate']>;
};


export type QueryCaregiversStateComplianceIssuesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  issue?: InputMaybe<String_Filter>;
  issueTypes?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiverStateCompliance__Order>>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryContractTypesArgs = {
  active?: InputMaybe<Boolean_Filter>;
  id?: InputMaybe<ContractTypeId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<ContractType__Order>>>;
};


export type QueryImportedVisitsArgs = {
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  endTimeLocal?: InputMaybe<LocalDateTime_Filter>;
  id?: InputMaybe<ImportedVisitId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberImportedVisit__Order>>>;
  startTimeLocal?: InputMaybe<LocalDateTime_Filter>;
};


export type QueryNotesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  id?: InputMaybe<NoteId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Note__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};


export type QueryOfficesArgs = {
  id?: InputMaybe<OfficeId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberOffice__Order>>>;
};


export type QueryPatientAuthorizationsArgs = {
  authorizationCode?: InputMaybe<String_Filter>;
  endDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<AuthorizationId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorization__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  serviceCode?: InputMaybe<ServiceCode_RelationFilter>;
  startDate?: InputMaybe<LocalDate_Filter>;
};


export type QueryPatientCustomFieldsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPatientIssuesArgs = {
  _severity?: InputMaybe<String_Filter>;
  _status?: InputMaybe<String_Filter>;
  _tags?: InputMaybe<String_List_Filter>;
  _type?: InputMaybe<String_Filter>;
  assignedAgencyMemberId?: InputMaybe<AgencyMemberId_Filter>;
  assigned_agency_member?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  description?: InputMaybe<String_Filter>;
  from?: InputMaybe<Scalars['LocalDate']>;
  id?: InputMaybe<PatientIssueId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<PatientIssue__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  resolutionDescription?: InputMaybe<String_Filter>;
  resulttedAt?: InputMaybe<Instant_Filter>;
  resulttedBy?: InputMaybe<AgencyMemberId_Filter>;
  resultted_by?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  search?: InputMaybe<Scalars['String']>;
  severities?: InputMaybe<Array<PatientIssueSeverity>>;
  sourceTicketId?: InputMaybe<CommCenterTicketId_Filter>;
  statuses?: InputMaybe<Array<PatientIssueStatus>>;
  tags?: InputMaybe<Array<PatientIssueTag>>;
  to?: InputMaybe<Scalars['LocalDate']>;
  types?: InputMaybe<Array<PatientIssueType>>;
};


export type QueryPatientLeadQualificationsArgs = {
  disqualifiedAt?: InputMaybe<Instant_Filter>;
  isQualified?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientLeadQualifications__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  qualifiedAt?: InputMaybe<Instant_Filter>;
  qualifiedReason?: InputMaybe<String_Filter>;
};


export type QueryPatientWebsiteVisitorEventsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  eventName?: InputMaybe<String_Filter>;
  eventType?: InputMaybe<String_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorEventId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__Order>>>;
  visit?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit_RelationFilter>;
  visitId?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};


export type QueryPatientWebsiteVisitorVisitsArgs = {
  adContent?: InputMaybe<String_Filter>;
  adGroup?: InputMaybe<String_Filter>;
  assignedPhoneNumber?: InputMaybe<String_Filter>;
  campaign?: InputMaybe<String_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  medium?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorVisit__Order>>>;
  searchTerm?: InputMaybe<String_Filter>;
  source?: InputMaybe<String_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};


export type QueryPatientWebsiteVisitorsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitor__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  uuid?: InputMaybe<String_Filter>;
};


export type QueryPatientsArgs = {
  active?: InputMaybe<Boolean_Filter>;
  addressSearch?: InputMaybe<Scalars['String']>;
  agencyBranchId?: InputMaybe<Array<Scalars['AgencyBranchId']>>;
  agencyTeam?: InputMaybe<AgencyTeam_RelationFilter>;
  agencyTeamId?: InputMaybe<AgencyTeamId_Filter>;
  assignedCoordinator?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  assignedCoordinatorId?: InputMaybe<AgencyMemberId_Filter>;
  contractTypeId?: InputMaybe<Array<Scalars['ContractTypeId']>>;
  createdAt?: InputMaybe<Instant_Filter>;
  createdBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  createdById?: InputMaybe<AgencyMemberId_Filter>;
  currentOffice?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  currentOfficeId?: InputMaybe<OfficeId_Filter>;
  displayId?: InputMaybe<Int_Filter>;
  displayIdSearch?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<LocalDate_Filter>;
  firstName?: InputMaybe<String_Filter>;
  firstNameSearch?: InputMaybe<Scalars['String']>;
  hasEmergencyKardexInfo?: InputMaybe<Boolean_Filter>;
  hasPhysicianInfo?: InputMaybe<Boolean_Filter>;
  homePhoneSearch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<PatientId_Filter>;
  lastName?: InputMaybe<String_Filter>;
  lastNameSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mobilePhoneSearch?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<Patient__Order>>>;
  search?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<String_Filter>;
  startOfCare?: InputMaybe<LocalDate_Filter>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryPhonebookContactsArgs = {
  destinationNumberType?: InputMaybe<String_Filter>;
  id?: InputMaybe<AgencyPhonebookContactId_Filter>;
  inboundCommCenterLabel?: InputMaybe<CommCenterLabel_RelationFilter>;
  inboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<PhonebookContact__Order>>>;
  outboundCommCenterLabel?: InputMaybe<CommCenterLabel_RelationFilter>;
  outboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  payerId?: InputMaybe<PayerId_Filter>;
  phoneNumber?: InputMaybe<String_Filter>;
  phonebookContactType?: InputMaybe<String_Filter>;
};


export type QueryReferralUsersArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  email?: InputMaybe<String_Filter>;
  emailSearch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<ReferralUserId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<ReferralUser__Order>>>;
  organization?: InputMaybe<String_Filter>;
  phoneNumber?: InputMaybe<String_Filter>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  phonebookContact?: InputMaybe<PhonebookContact_RelationFilter>;
  phonebookContactId?: InputMaybe<AgencyPhonebookContactId_Filter>;
  role?: InputMaybe<String_Filter>;
  search?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Instant_Filter>;
};


export type QueryTicketsArgs = {
  _priority?: InputMaybe<String_Filter>;
  _source?: InputMaybe<String_Filter>;
  _topic?: InputMaybe<String_Filter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  createdBy?: InputMaybe<UserId_Filter>;
  createdBySystem?: InputMaybe<Boolean_Filter>;
  enableAgencyResponse?: InputMaybe<Boolean_Filter>;
  id?: InputMaybe<CommCenterTicketId_Filter>;
  label?: InputMaybe<CommCenterLabel_RelationFilter>;
  labelId?: InputMaybe<CommCenterLabelId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<CommCenterTicket__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  phoneNumber?: InputMaybe<String_Filter>;
  phonebookContact?: InputMaybe<PhonebookContact_RelationFilter>;
  phonebookContactId?: InputMaybe<AgencyPhonebookContactId_Filter>;
  priority?: InputMaybe<Array<CommCenterLabelPriority>>;
  relatedVisitBroadcastId?: InputMaybe<VisitBroadcastId_Filter>;
  relatedVisitInstanceId?: InputMaybe<VisitInstanceId_Filter>;
  source?: InputMaybe<Array<CommCenterTicketSource>>;
  team?: InputMaybe<CommCenterTeam_RelationFilter>;
  teamId?: InputMaybe<CommCenterTeamId_Filter>;
  topic?: InputMaybe<Array<CommCenterTicketTopic>>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};


export type QueryVisitAssignmentsArgs = {
  assignee?: InputMaybe<VisitAssignmentAssignee_RelationFilter>;
  assigneeId?: InputMaybe<Array<Scalars['AgencyMemberId']>>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']>;
  id?: InputMaybe<VisitAssignmentId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<VisitAssignment__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
};


export type QueryVisitAssignmentsDistinctArgs = {
  assignee?: InputMaybe<VisitAssignmentAssignee_RelationFilter>;
  assigneeId?: InputMaybe<Array<Scalars['AgencyMemberId']>>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']>;
  id?: InputMaybe<VisitAssignmentId_Filter>;
  lastUnreadTicketAt?: InputMaybe<Instant_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<VisitAssignmentDistinct__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
};


export type QueryVisitBroadcastsArgs = {
  canceledAt?: InputMaybe<Instant_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<VisitBroadcastId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitBroadcast__Order>>>;
};


export type QueryVisitInstancesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']>;
  id?: InputMaybe<VisitInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitInstance__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};


export type QueryWorkflowAvailableTaskInstancesArgs = {
  assignee?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  assigneeId?: InputMaybe<AgencyMemberId_Filter>;
  assigneeSearch?: InputMaybe<Scalars['String']>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']>;
  description?: InputMaybe<String_Filter>;
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Boolean_Filter>;
  name?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberAvailableWorkflowTaskInstance__Order>>>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']>>;
  priority?: InputMaybe<Int_Filter>;
  severity?: InputMaybe<String_Filter>;
  skillIds?: InputMaybe<Array<Scalars['WorkflowSkillId']>>;
  taskNames?: InputMaybe<Array<Scalars['String']>>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
};


export type QueryWorkflowDefinitionsArgs = {
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  createHumanTaskOnFailure?: InputMaybe<Boolean_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowDefinitionId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowDefinition__Order>>>;
  owner?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  priority?: InputMaybe<Int_Filter>;
  published?: InputMaybe<Boolean_Filter>;
  severity?: InputMaybe<String_Filter>;
  timeout?: InputMaybe<Int_Filter>;
  version?: InputMaybe<Int_Filter>;
};


export type QueryWorkflowInstancesArgs = {
  canceledAt?: InputMaybe<Instant_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  completedAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowInstance__Order>>>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']>>;
  startedAt?: InputMaybe<Instant_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']>;
  status?: InputMaybe<String_Filter>;
  success?: InputMaybe<Boolean_Filter>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowManualStartedBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  workflowManualStartedById?: InputMaybe<AgencyMemberId_Filter>;
  workflowTriggerId?: InputMaybe<WorkflowDefinitionTriggerId_Filter>;
  workflowTriggerTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  workflowTriggerType?: InputMaybe<String_Filter>;
};


export type QueryWorkflowTagsArgs = {
  id?: InputMaybe<WorkflowTagId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTag__Order>>>;
};


export type QueryWorkflowTaskDefinitionsArgs = {
  id?: InputMaybe<String_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Boolean_Filter>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskDefinition__Order>>>;
  priority?: InputMaybe<Int_Filter>;
  severity?: InputMaybe<String_Filter>;
  type?: InputMaybe<String_Filter>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
};


export type QueryWorkflowTaskInstanceInputsArgs = {
  entity?: InputMaybe<String_Filter>;
  fieldName?: InputMaybe<String_Filter>;
  isArray?: InputMaybe<Boolean_Filter>;
  isNullable?: InputMaybe<Boolean_Filter>;
  isOptional?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceInput__Order>>>;
  type?: InputMaybe<String_Filter>;
  value?: InputMaybe<String_Filter>;
  valueOrd?: InputMaybe<Int_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};


export type QueryWorkflowTaskInstanceTagsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceTag__Order>>>;
  tagId?: InputMaybe<WorkflowTagId_Filter>;
  tagValue?: InputMaybe<String_Filter>;
  workflowTagDefinition?: InputMaybe<AgencyMemberWorkflowTag_RelationFilter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};


export type QueryWorkflowTaskInstancesArgs = {
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  clusterValue?: InputMaybe<String_Filter>;
  completedAt?: InputMaybe<Instant_Filter>;
  completedBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  completedById?: InputMaybe<AgencyMemberId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstance__Order>>>;
  priority?: InputMaybe<Int_Filter>;
  retryCount?: InputMaybe<Int_Filter>;
  severity?: InputMaybe<String_Filter>;
  success?: InputMaybe<Boolean_Filter>;
  systemTaskId?: InputMaybe<String_Filter>;
  systemTaskVersion?: InputMaybe<Int_Filter>;
  type?: InputMaybe<String_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstance?: InputMaybe<AgencyMemberWorkflowInstance_RelationFilter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinition?: InputMaybe<AgencyMemberWorkflowTaskDefinition_RelationFilter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
};

export type ReferralUser = {
  __typename?: 'ReferralUser';
  createdAt: Scalars['Instant'];
  email: Scalars['String'];
  id: Scalars['ReferralUserId'];
  name: Scalars['String'];
  organization: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  phonebookContact: PhonebookContact;
  phonebookContactId: Scalars['AgencyPhonebookContactId'];
  role: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Instant']>;
};

export type ReferralUserConnection = {
  __typename?: 'ReferralUserConnection';
  /** The nodes that match the query */
  nodes: Array<ReferralUser>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type ReferralUserId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ReferralUserId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ReferralUserId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ReferralUserId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ReferralUserId']>>;
};

export type ReferralUser__Order = {
  /** Field to order by */
  field?: InputMaybe<ReferralUser__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum ReferralUser__OrderField {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Name = 'name',
  Organization = 'organization',
  PhoneNumber = 'phoneNumber',
  PhonebookContactId = 'phonebookContactId',
  Role = 'role',
  UpdatedAt = 'updatedAt'
}

export type ServiceCode = {
  __typename?: 'ServiceCode';
  code: Scalars['String'];
  id: Scalars['ServiceCodeId'];
  isGlobal: Scalars['Boolean'];
  patientAuthorizations: PatientAuthorizationConnection;
};


export type ServiceCodePatientAuthorizationsArgs = {
  authorizationCode?: InputMaybe<String_Filter>;
  endDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<AuthorizationId_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorization__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  serviceCode?: InputMaybe<ServiceCode_RelationFilter>;
  startDate?: InputMaybe<LocalDate_Filter>;
};

/** Filter result rows based on the value of a field */
export type ServiceCodeId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ServiceCodeId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ServiceCodeId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ServiceCodeId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ServiceCodeId']>>;
};

export type ServiceCode_RelationFilter = {
  /** Filter based on "code" field */
  code?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<ServiceCodeId_Filter>;
  /** Filter based on "isGlobal" field */
  isGlobal?: InputMaybe<Boolean_Filter>;
};

/** Sort Direction (SQL ORDER BY ASC/DESC sorting) */
export enum SortDir {
  /** Ascending (default) */
  Asc = 'asc',
  /** Ascending with NULLs first */
  AscNullsFirst = 'ascNullsFirst',
  /** Descending */
  Desc = 'desc',
  /** Descending with NULLs last */
  DescNullsLast = 'descNullsLast'
}

export enum StateComplianceIssueType {
  ActiveInMedflytButHasTheWrongStatusInChrc = 'Active_in_Medflyt_but_has_the_wrong_status_in_CHRC',
  HasAtLeastOneVisitWithCicoButNoHireDate = 'Has_at_least_one_visit_with_CICO_but_no_hire_date',
  HasHireDateInMedflytButIsntRegisteredInHcr = 'Has_hire_date_in_Medflyt_but_isnt_registered_in_HCR',
  HasTerminationFileButNotOnTheRightStatusInMedflyt = 'Has_termination_file_but_not_on_the_right_status_in_Medflyt',
  InactiveInMedflytButNoSeparationDateInHcr = 'Inactive_in_Medflyt_but_no_separation_date_in_HCR',
  InactiveInMedflytButNotTerminatedInChrc = 'Inactive_in_Medflyt_but_not_terminated_in_CHRC',
  TerminatedInChrcButNoTerminationFileInMedflyt = 'Terminated_in_CHRC_but_no_termination_file_in_Medflyt'
}

/** Filter result rows based on the value of a field */
export type String_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['String']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['String']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['String']>>;
};

/** Filter result rows based on the value of a field */
export type String_List_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>;
};

/** Filter result rows based on the value of a field */
export type UserId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['UserId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['UserId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['UserId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['UserId']>>;
};

export type VisitAssignment = {
  __typename?: 'VisitAssignment';
  assignee: Maybe<VisitAssignmentAssignee>;
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  createdAt: Scalars['Instant'];
  id: Scalars['VisitAssignmentId'];
  notes: VisitAssignmentNoteAssocConnection;
  patient: Patient;
  patientId: Scalars['PatientId'];
  reason: VisitAssignmentReason;
  status: VisitAssignmentStatus;
  tickets: VisitAssignmentTicketAssocConnection;
  visitBroadcasts: VisitAssignmentVisitBroadcastAssocConnection;
  visitInstances: VisitAssignmentVisitInstanceAssocConnection;
};


export type VisitAssignmentNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Note_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ticket?: InputMaybe<CommCenterTicket_RelationFilter>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentVisitBroadcastsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type VisitAssignmentVisitInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type VisitAssignmentAssignee = {
  __typename?: 'VisitAssignmentAssignee';
  agencyMember: Maybe<AgencyMemberAgencyMember>;
  assignee_id: Maybe<Scalars['AgencyMemberId']>;
  assignment_id: Scalars['VisitAssignmentId'];
  createdBy: AgencyMemberAgencyMember;
  created_at: Scalars['Instant'];
  created_by: Scalars['AgencyMemberId'];
  visitAssignment: VisitAssignment;
};

export type VisitAssignmentAssignee_RelationFilter = {
  /** Filter based on "assignee_id" field */
  assignee_id?: InputMaybe<AgencyMemberId_Filter>;
};

export type VisitAssignmentConnection = {
  __typename?: 'VisitAssignmentConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignment>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitAssignmentDistinct = {
  __typename?: 'VisitAssignmentDistinct';
  assignee: Maybe<VisitAssignmentAssignee>;
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Maybe<Scalars['CaregiverId']>;
  createdAt: Scalars['Instant'];
  id: Scalars['VisitAssignmentId'];
  lastUnreadTicketAt: Maybe<Scalars['Instant']>;
  notes: VisitAssignmentNoteAssocConnection;
  patient: Patient;
  patientId: Scalars['PatientId'];
  reason: VisitAssignmentReason;
  resolvedCount: Scalars['Int'];
  status: VisitAssignmentStatus;
  tickets: VisitAssignmentTicketAssocConnection;
  unresolvedCount: Scalars['Int'];
  visitBroadcasts: VisitAssignmentVisitBroadcastAssocConnection;
  visitInstances: VisitAssignmentVisitInstanceAssocConnection;
};


export type VisitAssignmentDistinctNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Note_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentDistinctTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ticket?: InputMaybe<CommCenterTicket_RelationFilter>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentDistinctVisitBroadcastsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type VisitAssignmentDistinctVisitInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type VisitAssignmentDistinctConnection = {
  __typename?: 'VisitAssignmentDistinctConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentDistinct>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitAssignmentDistinct__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitAssignmentDistinct__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitAssignmentDistinct__OrderField {
  Reason = '_reason',
  Status = '_status',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  LastUnreadTicketAt = 'lastUnreadTicketAt',
  PatientId = 'patientId',
  ResolvedCount = 'resolvedCount',
  UnresolvedCount = 'unresolvedCount'
}

/** Filter result rows based on the value of a field */
export type VisitAssignmentId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['VisitAssignmentId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['VisitAssignmentId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['VisitAssignmentId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['VisitAssignmentId']>>;
};

export type VisitAssignmentNoteAssoc = {
  __typename?: 'VisitAssignmentNoteAssoc';
  note: Note;
  noteId: Scalars['NoteId'];
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId'];
};

export type VisitAssignmentNoteAssocConnection = {
  __typename?: 'VisitAssignmentNoteAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentNoteAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export enum VisitAssignmentReason {
  CannotAttendFirstVisit = 'CannotAttendFirstVisit',
  CannotAttendShift = 'CannotAttendShift',
  CannotAttendShiftChat = 'CannotAttendShiftChat',
  CannotAttendShiftLateClockInRobocall = 'CannotAttendShiftLateClockInRobocall',
  CannotAttendShiftRn = 'CannotAttendShiftRN',
  ChatRn = 'ChatRN',
  CoordinatorBroadcastedVisit = 'CoordinatorBroadcastedVisit',
  CoordinatorRemovedAllFutureVisits = 'CoordinatorRemovedAllFutureVisits',
  CoordinatorRemovedVisits = 'CoordinatorRemovedVisits',
  Default = 'Default',
  MissingClockIn = 'MissingClockIn',
  MissingPhysicianInfo = 'MissingPhysicianInfo',
  NoAnswerFirstVisitVerifyChat = 'NoAnswerFirstVisitVerifyChat',
  NoReplacementCancelledMoreThanOneShift = 'NoReplacementCancelledMoreThanOneShift',
  NoReplacementFirstMonthOfServices = 'NoReplacementFirstMonthOfServices',
  NursingVisitScheduling = 'NursingVisitScheduling',
  PatientCalled = 'PatientCalled',
  PatientMissedCall = 'PatientMissedCall',
  PatientMovedToSms = 'PatientMovedToSMS',
  PatientSentSms = 'PatientSentSMS',
  RnNote = 'RNNote',
  UnassignedVisit = 'UnassignedVisit',
  WantToStopWorkingWithPatientChat = 'WantToStopWorkingWithPatientChat'
}

export enum VisitAssignmentStatus {
  Resolved = 'Resolved',
  Unresolved = 'Unresolved'
}

export type VisitAssignmentTicketAssoc = {
  __typename?: 'VisitAssignmentTicketAssoc';
  commCenterTicketId: Scalars['CommCenterTicketId'];
  relations: Array<Scalars['String']>;
  ticket: CommCenterTicket;
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId'];
};

export type VisitAssignmentTicketAssocConnection = {
  __typename?: 'VisitAssignmentTicketAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentTicketAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitAssignmentVisitBroadcastAssoc = {
  __typename?: 'VisitAssignmentVisitBroadcastAssoc';
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId'];
  visitBroadcast: AgencyMemberVisitBroadcast;
  visitBroadcastId: Scalars['VisitBroadcastId'];
};

export type VisitAssignmentVisitBroadcastAssocConnection = {
  __typename?: 'VisitAssignmentVisitBroadcastAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentVisitBroadcastAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitAssignmentVisitInstanceAssoc = {
  __typename?: 'VisitAssignmentVisitInstanceAssoc';
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId'];
  visitInstance: AgencyMemberVisitInstance;
  visitInstanceId: Scalars['VisitInstanceId'];
};

export type VisitAssignmentVisitInstanceAssocConnection = {
  __typename?: 'VisitAssignmentVisitInstanceAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentVisitInstanceAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitAssignment_RelationFilter = {
  assigneeId?: InputMaybe<Array<Scalars['AgencyMemberId']>>;
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']>;
  /** Filter based on "id" field */
  id?: InputMaybe<VisitAssignmentId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
};

export type VisitAssignment__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitAssignment__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitAssignment__OrderField {
  Reason = '_reason',
  Status = '_status',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PatientId = 'patientId'
}

export type VisitBroadcastAssoc = {
  __typename?: 'VisitBroadcastAssoc';
  visitBroadcast: AgencyMemberVisitBroadcast;
  visitBroadcastId: Scalars['VisitBroadcastId'];
  visitInstanceId: Scalars['VisitInstanceId'];
  visitInstances: AgencyMemberVisitInstance;
};

export type VisitBroadcastAssocConnection = {
  __typename?: 'VisitBroadcastAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitBroadcastBroadcastedTo = {
  __typename?: 'VisitBroadcastBroadcastedTo';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId'];
  visitBroadcast: AgencyMemberVisitBroadcast;
  visitBroadcastId: Scalars['VisitBroadcastId'];
};

export type VisitBroadcastBroadcastedToConnection = {
  __typename?: 'VisitBroadcastBroadcastedToConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastBroadcastedTo>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitBroadcastBroadcastedTo__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitBroadcastBroadcastedTo__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitBroadcastBroadcastedTo__OrderField {
  CaregiverId = 'caregiverId'
}

export type VisitBroadcastCaregiverEngagement = {
  __typename?: 'VisitBroadcastCaregiverEngagement';
  acceptedTime: Scalars['Instant'];
  active: Scalars['Boolean'];
  cancelTime: Scalars['Instant'];
  caregiver: Maybe<AgencyMemberCaregiver>;
  caregiverId: Scalars['CaregiverId'];
  createdAt: Scalars['Instant'];
  id: Scalars['CaregiverVisitEngagementId'];
  isRequestActive: Scalars['Boolean'];
  moreDetailsViewedAt: Scalars['Instant'];
  notInterestedReason: Scalars['String'];
  notInterestedTime: Scalars['Instant'];
  viewedAt: Scalars['Instant'];
  visitBroadcast: Maybe<AgencyMemberVisitBroadcast>;
  visitBroadcastId: Scalars['VisitBroadcastId'];
};

export type VisitBroadcastCaregiverEngagementConnection = {
  __typename?: 'VisitBroadcastCaregiverEngagementConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastCaregiverEngagement>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitBroadcastCaregiverEngagement__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitBroadcastCaregiverEngagement__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitBroadcastCaregiverEngagement__OrderField {
  AcceptedTime = 'acceptedTime',
  Active = 'active',
  CancelTime = 'cancelTime',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsRequestActive = 'isRequestActive',
  MoreDetailsViewedAt = 'moreDetailsViewedAt',
  NotInterestedReason = 'notInterestedReason',
  NotInterestedTime = 'notInterestedTime',
  ViewedAt = 'viewedAt',
  VisitBroadcastId = 'visitBroadcastId'
}

export type VisitBroadcastCaregiverOverlappingImportedVisits = {
  __typename?: 'VisitBroadcastCaregiverOverlappingImportedVisits';
  /** The caregiver's imported visit that overlaps */
  caregiverImportedVisit: Maybe<AgencyMemberImportedVisit>;
  caregiverImportedVisitFromDifferentAgency: Scalars['Boolean'];
  /** The VisitInstance in this broadcast that overlaps */
  visitBroadcastVisitInstance: AgencyMemberVisitInstance;
};

export type VisitBroadcastCaregiverOverlappingImportedVisitsConnection = {
  __typename?: 'VisitBroadcastCaregiverOverlappingImportedVisitsConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastCaregiverOverlappingImportedVisits>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitBroadcastCaregiverOverlappingVisits = {
  __typename?: 'VisitBroadcastCaregiverOverlappingVisits';
  /** The caregiver's visit that overlaps */
  caregiverVisitInstance: Maybe<AgencyMemberVisitInstance>;
  caregiverVisitInstanceFromDifferentAgency: Scalars['Boolean'];
  /** The VisitInstance in this broadcast that overlaps */
  visitBroadcastVisitInstance: AgencyMemberVisitInstance;
};

export type VisitBroadcastCaregiverOverlappingVisitsConnection = {
  __typename?: 'VisitBroadcastCaregiverOverlappingVisitsConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastCaregiverOverlappingVisits>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type VisitBroadcastId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['VisitBroadcastId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['VisitBroadcastId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['VisitBroadcastId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['VisitBroadcastId']>>;
};

export type VisitBroadcastNotBroadcastedTo = {
  __typename?: 'VisitBroadcastNotBroadcastedTo';
  caregiverAvailabilityDaysConflict: Scalars['Boolean'];
  caregiverDistanceToVisitMeters: Scalars['Float'];
  caregiverHasOverlappingImportedVisits: Scalars['Boolean'];
  caregiverHasOverlappingVisits: Scalars['Boolean'];
  caregiverId: Scalars['CaregiverId'];
  caregiverMarkedNotInterested: Scalars['Boolean'];
  caregiverStatusMatches: Scalars['Boolean'];
  caregiverWithinRadius: Scalars['Boolean'];
  certificationMatches: Scalars['Boolean'];
  genderMatches: Scalars['Boolean'];
  languageMatches: Scalars['Boolean'];
  /** The caregiver's imported visits that are overlapping with this VisitBroadcast */
  overlappingImportedVisits: VisitBroadcastCaregiverOverlappingImportedVisitsConnection;
  /** The caregiver's visits that are overlapping with this VisitBroadcast */
  overlappingVisits: VisitBroadcastCaregiverOverlappingVisitsConnection;
  visitWithinAvailabilityMaxDistance: Scalars['Boolean'];
};


export type VisitBroadcastNotBroadcastedToOverlappingImportedVisitsArgs = {
  caregiverImportedVisit?: InputMaybe<AgencyMemberImportedVisit_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitBroadcastVisitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};


export type VisitBroadcastNotBroadcastedToOverlappingVisitsArgs = {
  caregiverVisitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visitBroadcastVisitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type VisitBroadcastNotBroadcastedToConnection = {
  __typename?: 'VisitBroadcastNotBroadcastedToConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastNotBroadcastedTo>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

export type VisitBroadcastNotBroadcastedTo__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitBroadcastNotBroadcastedTo__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitBroadcastNotBroadcastedTo__OrderField {
  CaregiverId = 'caregiverId',
  CaregiverMarkedNotInterested = 'caregiverMarkedNotInterested'
}

export type VisitInstanceAuthorizationAllocation = {
  __typename?: 'VisitInstanceAuthorizationAllocation';
  authorization: PatientAuthorization;
  authorizationId: Scalars['AuthorizationId'];
  minutesAllocated: Scalars['Int'];
  visitInstance: AgencyMemberVisitInstance;
  visitInstanceId: Scalars['VisitInstanceId'];
};

export type VisitInstanceAuthorizationAllocationConnection = {
  __typename?: 'VisitInstanceAuthorizationAllocationConnection';
  /** The nodes that match the query */
  nodes: Array<VisitInstanceAuthorizationAllocation>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int'];
};

/** Filter result rows based on the value of a field */
export type VisitInstanceId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['VisitInstanceId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['VisitInstanceId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['VisitInstanceId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['VisitInstanceId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowDefinitionCorrelationKey_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowDefinitionCorrelationKey']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowDefinitionCorrelationKey']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowDefinitionCorrelationKey']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowDefinitionCorrelationKey']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowDefinitionId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowDefinitionId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowDefinitionId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowDefinitionId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowDefinitionId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowDefinitionTriggerId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowDefinitionTriggerId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowDefinitionTriggerId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowDefinitionTriggerId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowDefinitionTriggerId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowInstanceId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowInstanceId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowInstanceId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowInstanceId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowInstanceId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowSkillId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowSkillId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowSkillId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowSkillId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowSkillId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowTagId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowTagId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowTagId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowTagId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowTagId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowTaskClusterId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowTaskClusterId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowTaskClusterId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowTaskClusterId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowTaskClusterId']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowTaskInstanceId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowTaskInstanceId']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowTaskInstanceId']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowTaskInstanceId']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowTaskInstanceId']>>;
};

export type GetAuthorizedPatientsWithoutVisitsQueryVariables = Exact<{
  order: Array<InputMaybe<AuthorizedPatientWithoutVisitsView__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
}>;


export type GetAuthorizedPatientsWithoutVisitsQuery = { __typename?: 'Query', authorizedPatientsWithoutVisits: { __typename?: 'AuthorizedPatientWithoutVisitsViewConnection', totalCount: number, nodes: Array<{ __typename?: 'AuthorizedPatientWithoutVisitsView', patient: { __typename?: 'Patient', id: schema.PatientId, firstName: string, middleName: string | null, lastName: string, status: schema.components["schemas"]["PatientStatus"], displayId: number | null, gender: schema.components["schemas"]["Patient"]["gender"] | null }, patientAuthorization: { __typename?: 'PatientAuthorization', id: schema.AuthorizationId, startDate: LocalDate, endDate: LocalDate } }> } };

export type GetCaregiversFullNamesQueryVariables = Exact<{
  ids: CaregiverId_Filter;
}>;


export type GetCaregiversFullNamesQuery = { __typename?: 'Query', caregivers: { __typename?: 'AgencyMemberCaregiverConnection', totalCount: number, nodes: Array<{ __typename?: 'AgencyMemberCaregiver', id: schema.CaregiverId, displayId: number | null, firstName: string, lastName: string }> } };

export type GetCaregiversHcrComplianceQueryVariables = Exact<{
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  search?: InputMaybe<Scalars['String']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  order: Array<InputMaybe<AgencyMemberCaregiverHcrCompliance__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  fromHireDate?: InputMaybe<Scalars['LocalDate']>;
  toHireDate?: InputMaybe<Scalars['LocalDate']>;
}>;


export type GetCaregiversHcrComplianceQuery = { __typename?: 'Query', caregiversHcrCompliance: { __typename?: 'AgencyMemberCaregiverHcrComplianceConnection', totalCount: number, nodes: Array<{ __typename?: 'AgencyMemberCaregiverHcrCompliance', id: schema.MedflytHCRDataId, hcrStateRegistryNumber: number | null, hcrFullName: string, hcrCertificateType: string, hcrDateOfBirth: LocalDate, hcrHireDate: LocalDate | null, hcrSeparationDate: LocalDate | null, caregiverId: schema.CaregiverId | null, status: schema.components["schemas"]["CaregiverStatus"] | null, hireDate: LocalDate | null, dateOfBirth: LocalDate | null, terminationDate: LocalDate | null, stateRegistryNum: number | null, caregiver: { __typename?: 'AgencyMemberCaregiver', firstName: string, middleName: string | null, lastName: string, avatarUrl: string | null, displayId: number | null } | null }> } };

export type GetCaregiversChrcComplianceQueryVariables = Exact<{
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  search?: InputMaybe<Scalars['String']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  chrcStatus?: InputMaybe<String_Filter>;
  order: Array<InputMaybe<AgencyMemberCaregiverChrcCompliance__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  fromHireDate?: InputMaybe<Scalars['LocalDate']>;
  toHireDate?: InputMaybe<Scalars['LocalDate']>;
  fromChrcStartDate?: InputMaybe<Scalars['LocalDate']>;
  toChrcStartDate?: InputMaybe<Scalars['LocalDate']>;
}>;


export type GetCaregiversChrcComplianceQuery = { __typename?: 'Query', caregiversChrcCompliance: { __typename?: 'AgencyMemberCaregiverChrcComplianceConnection', totalCount: number, nodes: Array<{ __typename?: 'AgencyMemberCaregiverChrcCompliance', id: schema.MedflytCHRCDataId, chrcEmployeeName: string, chrcDateOfBirth: LocalDate, chrcStartDate: LocalDate, chrcStatus: string, chrcStatusDate: LocalDate, caregiverId: schema.CaregiverId | null, status: schema.components["schemas"]["CaregiverStatus"] | null, hireDate: LocalDate | null, dateOfBirth: LocalDate | null, terminationDate: LocalDate | null, stateRegistryNum: number | null, caregiver: { __typename?: 'AgencyMemberCaregiver', firstName: string, middleName: string | null, lastName: string, avatarUrl: string | null, displayId: number | null } | null }> } };

export type GetCaregiversStateComplianceIssuesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  issueTypes?: InputMaybe<Array<Scalars['String']>>;
  order: Array<InputMaybe<AgencyMemberCaregiverStateCompliance__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetCaregiversStateComplianceIssuesQuery = { __typename?: 'Query', caregiversStateComplianceIssues: { __typename?: 'AgencyMemberCaregiverStateComplianceConnection', totalCount: number, nodes: Array<{ __typename?: 'AgencyMemberCaregiverStateCompliance', issue: StateComplianceIssueType, caregiverId: schema.CaregiverId, caregiver: { __typename?: 'AgencyMemberCaregiver', id: schema.CaregiverId, firstName: string, middleName: string | null, lastName: string, avatarUrl: string | null, displayId: number | null, status: schema.components["schemas"]["CaregiverStatus"] } }> } };

export type GetPatientsQueryVariables = Exact<{
  order: Array<InputMaybe<Patient__Order>>;
  limit: Scalars['Int'];
  id?: InputMaybe<PatientId_Filter>;
  offset: Scalars['Int'];
  statuses?: InputMaybe<Array<Scalars['String']>>;
  offices?: InputMaybe<OfficeId_Filter>;
  contracts?: InputMaybe<Array<Scalars['ContractTypeId']>>;
  teams?: InputMaybe<AgencyTeamId_Filter>;
  assigned?: InputMaybe<AgencyMemberId_Filter>;
  displayIdSearch?: InputMaybe<Scalars['String']>;
  firstNameSearch?: InputMaybe<Scalars['String']>;
  lastNameSearch?: InputMaybe<Scalars['String']>;
  addressSearch?: InputMaybe<Scalars['String']>;
  mobilePhoneSearch?: InputMaybe<Scalars['String']>;
  homePhoneSearch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPatientsQuery = { __typename?: 'Query', patients: { __typename?: 'PatientConnection', totalCount: number, nodes: Array<{ __typename?: 'Patient', id: schema.PatientId, displayId: number | null, firstName: string, lastName: string, address: string | null, gender: schema.components["schemas"]["Patient"]["gender"] | null, homePhoneNumber: string | null, mobilePhoneNumber: string | null, dateOfBirth: LocalDate | null, startOfCare: LocalDate | null, customFields: schema.components["schemas"]["EntityCustomField"], status: schema.components["schemas"]["PatientStatus"], effectiveDate: LocalDate | null, createdAt: Instant, agencyTeam: { __typename?: 'AgencyTeam', name: string } | null, assignedCoordinator: { __typename?: 'AgencyMemberAgencyMember', firstName: string, lastName: string } | null, currentOffice: { __typename?: 'AgencyMemberOffice', name: string }, activeContracts: { __typename?: 'PatientActiveContractsConnection', nodes: Array<{ __typename?: 'PatientActiveContracts', patientContract: { __typename?: 'PatientContract', memberId: string, medicaidNumber: string | null }, contractType: { __typename?: 'ContractType', name: string } }> }, createdBy: { __typename?: 'AgencyMemberAgencyMember', firstName: string, lastName: string } }> } };

export type GetPatientComplianceQueryVariables = Exact<{
  order: Array<InputMaybe<Patient__Order>>;
  limit: Scalars['Int'];
  id?: InputMaybe<PatientId_Filter>;
  offset: Scalars['Int'];
  statuses?: InputMaybe<Array<Scalars['String']>>;
  assigned?: InputMaybe<AgencyMemberId_Filter>;
  displayIdSearch?: InputMaybe<Scalars['String']>;
  firstNameSearch?: InputMaybe<Scalars['String']>;
  lastNameSearch?: InputMaybe<Scalars['String']>;
  addressSearch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  startOfCare?: InputMaybe<LocalDate_Filter>;
}>;


export type GetPatientComplianceQuery = { __typename?: 'Query', patients: { __typename?: 'PatientConnection', totalCount: number, nodes: Array<{ __typename?: 'Patient', id: schema.PatientId, displayId: number | null, firstName: string, lastName: string, status: schema.components["schemas"]["PatientStatus"], createdAt: Instant, startOfCare: LocalDate | null, hasPhysicianInfo: boolean, hasEmergencyKardexInfo: boolean, createdBy: { __typename?: 'AgencyMemberAgencyMember', firstName: string, lastName: string }, firstStartOfCare: { __typename?: 'PatientCertificationPeriod', startDate: LocalDate, endDate: LocalDate, isCompleted: boolean, totalRequiredDocuments: number, totalSubmittedDocuments: number, latestTaskInstance: { __typename?: 'PatientTaskInstance', startDate: LocalDate, completionDate: LocalDate | null } | null } | null, lastStartOfCare: { __typename?: 'PatientCertificationPeriod', startDate: LocalDate, endDate: LocalDate, isCompleted: boolean, totalRequiredDocuments: number, totalSubmittedDocuments: number, latestTaskInstance: { __typename?: 'PatientTaskInstance', startDate: LocalDate, completionDate: LocalDate | null } | null } | null, lastReassessment: { __typename?: 'PatientCertificationPeriod', startDate: LocalDate, endDate: LocalDate, daysFromStartDate: number, daysFromEndDate: number, totalRequiredDocuments: number, totalSubmittedDocuments: number, latestTaskInstance: { __typename?: 'PatientTaskInstance', startDate: LocalDate, completionDate: LocalDate | null } | null } | null, nextReassessment: { __typename?: 'PatientCertificationPeriod', startDate: LocalDate, endDate: LocalDate, daysFromStartDate: number, daysFromEndDate: number, totalRequiredDocuments: number, totalSubmittedDocuments: number, latestTaskInstance: { __typename?: 'PatientTaskInstance', startDate: LocalDate, completionDate: LocalDate | null } | null } | null }> } };

export type GetPatientIssuesQueryVariables = Exact<{
  order: Array<InputMaybe<PatientIssue__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
  types?: InputMaybe<Array<PatientIssueType>>;
  statuses?: InputMaybe<Array<PatientIssueStatus>>;
  severities?: InputMaybe<Array<PatientIssueSeverity>>;
  tags?: InputMaybe<Array<PatientIssueTag>>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPatientIssuesQuery = { __typename?: 'Query', patientIssues: { __typename?: 'PatientIssueConnection', totalCount: number, nodes: Array<{ __typename?: 'PatientIssue', id: schema.PatientIssueId, type: PatientIssueType, description: string, createdAt: Instant, caregiverId: schema.CaregiverId | null, resolutionDescription: string | null, severity: PatientIssueSeverity, sourceTicketId: schema.CommCenterTicketId, status: PatientIssueStatus, _tags: Array<string | null> | null, resulttedAt: Instant | null, assigned_agency_member: { __typename?: 'AgencyMemberAgencyMember', full_name: string, id: schema.AgencyMemberId } | null, patient: { __typename?: 'Patient', firstName: string, lastName: string, id: schema.PatientId, status: schema.components["schemas"]["PatientStatus"], displayId: number | null, gender: schema.components["schemas"]["Patient"]["gender"] | null }, caregiver: { __typename?: 'AgencyMemberCaregiver', id: schema.CaregiverId, displayId: number | null, firstName: string, middleName: string | null, lastName: string, status: schema.components["schemas"]["CaregiverStatus"], avatarUrl: string | null } | null, resultted_by: { __typename?: 'AgencyMemberAgencyMember', id: schema.AgencyMemberId, full_name: string } | null }> } };

export type GetReferralUsersQueryVariables = Exact<{
  order?: InputMaybe<Array<ReferralUser__Order>>;
  limit: Scalars['Int'];
  id?: InputMaybe<ReferralUserId_Filter>;
  offset: Scalars['Int'];
  role?: InputMaybe<String_Filter>;
  organization?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['String']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  emailSearch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetReferralUsersQuery = { __typename?: 'Query', referralUsers: { __typename?: 'ReferralUserConnection', totalCount: number, nodes: Array<{ __typename?: 'ReferralUser', id: schema.ReferralUserId, phonebookContactId: schema.AgencyPhonebookContactId, name: string, email: string, role: string | null, organization: string | null, createdAt: Instant, updatedAt: Instant | null, phoneNumber: string }> } };

export type GetVisitAssignmentRelatedAutomationsQueryVariables = Exact<{
  tagValue: Scalars['String'];
}>;


export type GetVisitAssignmentRelatedAutomationsQuery = { __typename?: 'Query', workflowTaskInstanceTags: { __typename?: 'AgencyMemberWorkflowTaskInstanceTagConnection', nodes: Array<{ __typename?: 'AgencyMemberWorkflowTaskInstanceTag', workflowTaskInstance: { __typename?: 'AgencyMemberWorkflowTaskInstance', id: schema.WorkflowTaskInstanceId, createdAt: Instant, workflowInstance: { __typename?: 'AgencyMemberWorkflowInstance', id: schema.WorkflowInstanceId }, workflowTaskDefinition: { __typename?: 'AgencyMemberWorkflowTaskDefinition', name: string, workflowDefinition: { __typename?: 'AgencyMemberWorkflowDefinition', id: schema.WorkflowDefinitionId, name: string } } | null } }> } };

export type GetVisitAssignmentsQueryVariables = Exact<{
  order: Array<InputMaybe<VisitAssignmentDistinct__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
  patientId?: InputMaybe<PatientId_Filter>;
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
  assignedAgencyMemberId?: InputMaybe<Array<Scalars['AgencyMemberId']>>;
}>;


export type GetVisitAssignmentsQuery = { __typename?: 'Query', visitAssignmentsDistinct: { __typename?: 'VisitAssignmentDistinctConnection', totalCount: number, nodes: Array<{ __typename?: 'VisitAssignmentDistinct', id: schema.VisitAssignmentId, reason: VisitAssignmentReason, status: VisitAssignmentStatus, createdAt: Instant, unresolvedCount: number, lastUnreadTicketAt: Instant | null, patient: { __typename?: 'Patient', id: schema.PatientId, displayId: number | null, firstName: string, middleName: string | null, lastName: string, status: schema.components["schemas"]["PatientStatus"], gender: schema.components["schemas"]["Patient"]["gender"] | null }, caregiver: { __typename?: 'AgencyMemberCaregiver', id: schema.CaregiverId, displayId: number | null, firstName: string, middleName: string | null, lastName: string, status: schema.components["schemas"]["CaregiverStatus"], avatarUrl: string | null } | null, assignee: { __typename?: 'VisitAssignmentAssignee', agencyMember: { __typename?: 'AgencyMemberAgencyMember', id: schema.AgencyMemberId, full_name: string, photoUrl: string | null } | null } | null, visitInstances: { __typename?: 'VisitAssignmentVisitInstanceAssocConnection', nodes: Array<{ __typename?: 'VisitAssignmentVisitInstanceAssoc', visitInstance: { __typename?: 'AgencyMemberVisitInstance', id: schema.VisitInstanceId, startTimeLocal: PermissionControlledField_LocalDateTime, endTimeLocal: PermissionControlledField_LocalDateTime } }> }, visitBroadcasts: { __typename?: 'VisitAssignmentVisitBroadcastAssocConnection', nodes: Array<{ __typename?: 'VisitAssignmentVisitBroadcastAssoc', visitBroadcast: { __typename?: 'AgencyMemberVisitBroadcast', id: schema.VisitBroadcastId, engagements: { __typename?: 'VisitBroadcastCaregiverEngagementConnection', nodes: Array<{ __typename?: 'VisitBroadcastCaregiverEngagement', id: unknown, isRequestActive: boolean }> } } }> }, tickets: { __typename?: 'VisitAssignmentTicketAssocConnection', nodes: Array<{ __typename?: 'VisitAssignmentTicketAssoc', ticket: { __typename?: 'CommCenterTicket', id: schema.CommCenterTicketId, unreadCount: number } }> } }> } };

export type GetVisitAssignmentQueryVariables = Exact<{
  id: Scalars['VisitAssignmentId'];
}>;


export type GetVisitAssignmentQuery = { __typename?: 'Query', visitAssignments: { __typename?: 'VisitAssignmentConnection', nodes: Array<{ __typename?: 'VisitAssignment', id: schema.VisitAssignmentId, reason: VisitAssignmentReason, status: VisitAssignmentStatus, createdAt: Instant, patient: { __typename?: 'Patient', id: schema.PatientId, firstName: string, lastName: string, displayId: number | null, gender: schema.components["schemas"]["Patient"]["gender"] | null, phoneNumbers: { __typename?: 'PatientPhoneNumberConnection', nodes: Array<{ __typename?: 'PatientPhoneNumber', type: string, label: string | null, phonenumber: string, description: string | null }> } }, assignee: { __typename?: 'VisitAssignmentAssignee', agencyMember: { __typename?: 'AgencyMemberAgencyMember', id: schema.AgencyMemberId, full_name: string, photoUrl: string | null } | null } | null, caregiver: { __typename?: 'AgencyMemberCaregiver', id: schema.CaregiverId, firstName: string, lastName: string, displayId: number | null, avatarUrl: string | null, phoneNumbers: { __typename?: 'AgencyMemberCaregiverPhoneNumberConnection', nodes: Array<{ __typename?: 'AgencyMemberCaregiverPhoneNumber', phoneNumber: string }> } } | null, visitInstances: { __typename?: 'VisitAssignmentVisitInstanceAssocConnection', nodes: Array<{ __typename?: 'VisitAssignmentVisitInstanceAssoc', visitInstance: { __typename?: 'AgencyMemberVisitInstance', id: schema.VisitInstanceId, startTimeLocal: PermissionControlledField_LocalDateTime, endTimeLocal: PermissionControlledField_LocalDateTime } }> }, visitBroadcasts: { __typename?: 'VisitAssignmentVisitBroadcastAssocConnection', nodes: Array<{ __typename?: 'VisitAssignmentVisitBroadcastAssoc', visitBroadcast: { __typename?: 'AgencyMemberVisitBroadcast', id: schema.VisitBroadcastId, startTimeLocal: LocalDateTime, endTimeLocal: LocalDateTime, canceledAt: Instant | null, engagements: { __typename?: 'VisitBroadcastCaregiverEngagementConnection', nodes: Array<{ __typename?: 'VisitBroadcastCaregiverEngagement', id: unknown, isRequestActive: boolean }> } } }> } }> } };

export type GetRelatedVisitAssignmentQueryVariables = Exact<{
  id: Scalars['VisitAssignmentId'];
  patientId: Scalars['PatientId'];
  createdAtFrom: Scalars['LocalDate'];
}>;


export type GetRelatedVisitAssignmentQuery = { __typename?: 'Query', unresolved: { __typename?: 'VisitAssignmentConnection', nodes: Array<{ __typename?: 'VisitAssignment', id: schema.VisitAssignmentId, reason: VisitAssignmentReason, status: VisitAssignmentStatus, createdAt: Instant }> }, resolved: { __typename?: 'VisitAssignmentConnection', nodes: Array<{ __typename?: 'VisitAssignment', id: schema.VisitAssignmentId, reason: VisitAssignmentReason, status: VisitAssignmentStatus, createdAt: Instant }> } };

export type GetAvailableWorkflowTasksQueryVariables = Exact<{
  order: Array<InputMaybe<AgencyMemberAvailableWorkflowTaskInstance__Order>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  assigneeId?: InputMaybe<AgencyMemberId_Filter>;
  assigneeSearch?: InputMaybe<Scalars['String']>;
  taskName?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['String']>;
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  skillIds?: InputMaybe<Array<Scalars['WorkflowSkillId']>>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']>>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']>>;
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']>;
}>;


export type GetAvailableWorkflowTasksQuery = { __typename?: 'Query', workflowAvailableTaskInstances: { __typename?: 'AgencyMemberAvailableWorkflowTaskInstanceConnection', totalCount: number, nodes: Array<{ __typename?: 'AgencyMemberAvailableWorkflowTaskInstance', id: schema.WorkflowTaskInstanceId, name: string, description: string | null, mandatory: boolean, priority: number, severity: string, assignmentTimeoutSeconds: number | null, createdAt: Instant, clusterId: schema.WorkflowTaskClusterId | null, clusterValue: string | null, workflowDefinition: { __typename?: 'AgencyMemberWorkflowDefinition', id: schema.WorkflowDefinitionId, name: string }, skills: { __typename?: 'AgencyMemberWorkflowTaskSkillConnection', nodes: Array<{ __typename?: 'AgencyMemberWorkflowTaskSkill', id: schema.WorkflowSkillId }> }, instanceEntities: { __typename?: 'AgencyMemberWorkflowInstanceInputEntitiesConnection', nodes: Array<{ __typename?: 'AgencyMemberWorkflowInstanceInputEntities', key: string, entity: string, value: any }> }, assignee: { __typename?: 'AgencyMemberAgencyMember', id: schema.AgencyMemberId, firstName: string, lastName: string } | null }> } };


export const GetAuthorizedPatientsWithoutVisitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthorizedPatientsWithoutVisits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorizedPatientWithoutVisitsView__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizedPatientsWithoutVisits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientAuthorization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthorizedPatientsWithoutVisitsQuery, GetAuthorizedPatientsWithoutVisitsQueryVariables>;
export const GetCaregiversFullNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaregiversFullNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverId_Filter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caregivers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GetCaregiversFullNamesQuery, GetCaregiversFullNamesQueryVariables>;
export const GetCaregiversHcrComplianceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaregiversHcrCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyUnmatched"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberCaregiverHcrCompliance__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromHireDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toHireDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caregiversHcrCompliance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"caregiverIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyUnmatched"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyUnmatched"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromHireDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromHireDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toHireDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toHireDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hcrStateRegistryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"hcrFullName"}},{"kind":"Field","name":{"kind":"Name","value":"hcrCertificateType"}},{"kind":"Field","name":{"kind":"Name","value":"hcrDateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"hcrHireDate"}},{"kind":"Field","name":{"kind":"Name","value":"hcrSeparationDate"}},{"kind":"Field","name":{"kind":"Name","value":"caregiverId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hireDate"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"stateRegistryNum"}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCaregiversHcrComplianceQuery, GetCaregiversHcrComplianceQueryVariables>;
export const GetCaregiversChrcComplianceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaregiversChrcCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyUnmatched"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chrcStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberCaregiverChrcCompliance__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromHireDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toHireDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromChrcStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toChrcStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caregiversChrcCompliance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chrcStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"caregiverIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyUnmatched"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyUnmatched"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromHireDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromHireDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toHireDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toHireDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromChrcStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromChrcStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toChrcStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toChrcStartDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chrcEmployeeName"}},{"kind":"Field","name":{"kind":"Name","value":"chrcDateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"chrcStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"chrcStatus"}},{"kind":"Field","name":{"kind":"Name","value":"chrcStatusDate"}},{"kind":"Field","name":{"kind":"Name","value":"caregiverId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hireDate"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}},{"kind":"Field","name":{"kind":"Name","value":"stateRegistryNum"}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCaregiversChrcComplianceQuery, GetCaregiversChrcComplianceQueryVariables>;
export const GetCaregiversStateComplianceIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaregiversStateComplianceIssues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberCaregiverStateCompliance__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caregiversStateComplianceIssues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"issueTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"}},{"kind":"Field","name":{"kind":"Name","value":"caregiverId"}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCaregiversStateComplianceIssuesQuery, GetCaregiversStateComplianceIssuesQueryVariables>;
export const GetPatientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPatients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Patient__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offices"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OfficeId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contracts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTypeId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teams"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyTeamId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigned"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayIdSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobilePhoneSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homePhoneSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayIdSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayIdSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentOfficeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offices"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contracts"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyTeamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teams"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedCoordinatorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigned"}}},{"kind":"Argument","name":{"kind":"Name","value":"addressSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"mobilePhoneSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobilePhoneSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"homePhoneSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homePhoneSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"homePhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"startOfCare"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}},{"kind":"Field","name":{"kind":"Name","value":"agencyTeam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedCoordinator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentOffice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeContracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientContract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"medicaidNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPatientsQuery, GetPatientsQueryVariables>;
export const GetPatientComplianceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPatientCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Patient__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigned"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayIdSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startOfCare"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate_Filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayIdSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayIdSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedCoordinatorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigned"}}},{"kind":"Argument","name":{"kind":"Name","value":"addressSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"startOfCare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startOfCare"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startOfCare"}},{"kind":"Field","name":{"kind":"Name","value":"firstStartOfCare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","alias":{"kind":"Name","value":"totalRequiredDocuments"},"name":{"kind":"Name","value":"documents"}},{"kind":"Field","alias":{"kind":"Name","value":"totalSubmittedDocuments"},"name":{"kind":"Name","value":"submitted"}},{"kind":"Field","name":{"kind":"Name","value":"latestTaskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStartOfCare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","alias":{"kind":"Name","value":"totalRequiredDocuments"},"name":{"kind":"Name","value":"documents"}},{"kind":"Field","alias":{"kind":"Name","value":"totalSubmittedDocuments"},"name":{"kind":"Name","value":"submitted"}},{"kind":"Field","name":{"kind":"Name","value":"latestTaskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastReassessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysFromStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysFromEndDate"}},{"kind":"Field","alias":{"kind":"Name","value":"totalRequiredDocuments"},"name":{"kind":"Name","value":"documents"}},{"kind":"Field","alias":{"kind":"Name","value":"totalSubmittedDocuments"},"name":{"kind":"Name","value":"submitted"}},{"kind":"Field","name":{"kind":"Name","value":"latestTaskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextReassessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysFromStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysFromEndDate"}},{"kind":"Field","alias":{"kind":"Name","value":"totalRequiredDocuments"},"name":{"kind":"Name","value":"documents"}},{"kind":"Field","alias":{"kind":"Name","value":"totalSubmittedDocuments"},"name":{"kind":"Name","value":"submitted"}},{"kind":"Field","name":{"kind":"Name","value":"latestTaskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPhysicianInfo"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmergencyKardexInfo"}}]}}]}}]}}]} as unknown as DocumentNode<GetPatientComplianceQuery, GetPatientComplianceQueryVariables>;
export const GetPatientIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPatientIssues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientIssue__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientIssueType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientIssueStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"severities"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientIssueSeverity"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientIssueTag"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientIssues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"severities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"severities"}}},{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"caregiverId"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"sourceTicketId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"_tags"}},{"kind":"Field","name":{"kind":"Name","value":"resulttedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_agency_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resultted_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetPatientIssuesQuery, GetPatientIssuesQueryVariables>;
export const GetReferralUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReferralUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralUser__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralUserId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organization"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"Argument","name":{"kind":"Name","value":"organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organization"}}},{"kind":"Argument","name":{"kind":"Name","value":"nameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"emailSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phonebookContactId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]} as unknown as DocumentNode<GetReferralUsersQuery, GetReferralUsersQueryVariables>;
export const GetVisitAssignmentRelatedAutomationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisitAssignmentRelatedAutomations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowTaskInstanceTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tagValue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagValue"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"createdAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"workflowTaskInstance"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowTaskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workflowInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflowTaskDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workflowDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisitAssignmentRelatedAutomationsQuery, GetVisitAssignmentRelatedAutomationsQueryVariables>;
export const GetVisitAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisitAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitAssignmentDistinct__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitAssignmentReason"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitAssignmentStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedAgencyMemberId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberId"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitAssignmentsDistinct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createdAtFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAtTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"assigneeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedAgencyMemberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"unresolvedCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUnreadTicketAt"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visitInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeLocal"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visitBroadcasts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitBroadcast"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitBroadcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"engagements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isRequestActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRequestActive"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unreadCount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisitAssignmentsQuery, GetVisitAssignmentsQueryVariables>;
export const GetVisitAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisitAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitAssignmentId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"phonenumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visitInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeLocal"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visitBroadcasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitBroadcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeLocal"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isRequestActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRequestActive"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisitAssignmentQuery, GetVisitAssignmentQueryVariables>;
export const GetRelatedVisitAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelatedVisitAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitAssignmentId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAtFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unresolved"},"name":{"kind":"Name","value":"visitAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"createdAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Unresolved"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"resolved"},"name":{"kind":"Name","value":"visitAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"createdAtFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"createdAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Resolved"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetRelatedVisitAssignmentQuery, GetRelatedVisitAssignmentQueryVariables>;
export const GetAvailableWorkflowTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableWorkflowTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberAvailableWorkflowTaskInstance__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTaskInstanceId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigneeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigneeSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"correlationKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowDefinitionCorrelationKey_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skillIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowSkillId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clusterId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTaskClusterId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAtFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAtTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowAvailableTaskInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"assigneeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigneeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"assigneeSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigneeSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskName"}}},{"kind":"Argument","name":{"kind":"Name","value":"nameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"correlationKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"correlationKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"skillIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skillIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"caregiverIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"clusterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clusterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAtFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAtTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentTimeoutSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"clusterId"}},{"kind":"Field","name":{"kind":"Name","value":"clusterValue"}},{"kind":"Field","name":{"kind":"Name","value":"workflowDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAvailableWorkflowTasksQuery, GetAvailableWorkflowTasksQueryVariables>;

export type PermissionControlledField_boolean = PermissionControlledField<boolean>;
export type PermissionControlledField_DayOfWeek = PermissionControlledField<DayOfWeek>;
export type PermissionControlledField_Instant = PermissionControlledField<Instant>;
export type PermissionControlledField_LocalDate = PermissionControlledField<LocalDate>;
export type PermissionControlledField_LocalDateTime = PermissionControlledField<LocalDateTime>;
export type PermissionControlledField_LocalTime = PermissionControlledField<LocalTime>;
export type PermissionControlledField_number = PermissionControlledField<number>;
export type PermissionControlledField_string = PermissionControlledField<string>;
export type PermissionControlledField_nullable_boolean = PermissionControlledField<boolean | null>;
export type PermissionControlledField_nullable_DayOfWeek = PermissionControlledField<DayOfWeek | null>;
export type PermissionControlledField_nullable_Instant = PermissionControlledField<Instant | null>;
export type PermissionControlledField_nullable_LocalDate = PermissionControlledField<LocalDate | null>;
export type PermissionControlledField_nullable_LocalDateTime = PermissionControlledField<LocalDateTime | null>;
export type PermissionControlledField_nullable_LocalTime = PermissionControlledField<LocalTime | null>;
export type PermissionControlledField_nullable_number = PermissionControlledField<number | null>;
export type PermissionControlledField_nullable_string = PermissionControlledField<string | null>;
export interface PermissionControlledField<T> {
  value: PermissionControlledValue<T>;
  requiredReadPermission: schema.components["schemas"]["AgencyMemberPermission"] | null;
  requiredEditPermission: schema.components["schemas"]["AgencyMemberPermission"] | null;
}
export type PermissionControlledValue<T> =
  | PermissionControlledValue.Value<T>
  | PermissionControlledValue.PermissionDenied;
export namespace PermissionControlledValue {
  export interface Value<T> {
    type: "Value";
    value: T;
    canEdit: boolean;
  }
  export interface PermissionDenied {
    type: "PermissionDenied";
  }
}
